{
  "dashboard": {
    "title": "Dashboard",
    "filters": {
      "dateFrom": "Date From",
      "dateTo": "Date To",
      "client": "Client",
      "entities": "Entities",
      "allClients": "All Clients",
      "allEntities": "All my entities/subentities",
      "movementType": "Movement Type",
      "allMovementTypes": "All",
      "searchPlaceholder": "Search...",
      "noResults": "No results found",
      "reset": "Reset Filters",
      "removeFilter": "Remove filter"
    },
    "granularity": {
      "day": "Day",
      "week": "Week",
      "month": "Month",
      "quarter": "Quarter",
      "year": "Year"
    },
    "admin": {
      "kpis": {
        "totalRevenue": "TOTAL REVENUE",
        "transportPart": "transport",
        "expensesRepercutidosPart": "passed-on expenses",
        "expensesNoRepercutidosPart": "non-passed expenses",
        "profitMargin": "PROFIT MARGIN",
        "marginRatio": "Margin",
        "cancellationCosts": "CANCELLATION COSTS",
        "cancellationRatio": "of created transports",
        "pendingIncidents": "PENDING INCIDENTS",
        "claims": "Claims",
        "breakdowns": "Breakdowns",
        "additionalExpenses": "ADDITIONAL EXPENSES",
        "repercutidos": "passed-on",
        "noRepercutidos": "non-passed",
        "completedTransports": "COMPLETED TRANSPORTS",
        "cancelledTransports": "CANCELLED TRANSPORTS",
        "averageTicket": "AVERAGE TICKET",
        "averageDistance": "AVERAGE DISTANCE PER TRANSPORT",
        "activeDrivers": "ACTIVE DRIVERS"
      },
      "charts": {
        "revenueEvolutionTitle": "Revenue by period",
        "revenueEvolutionSubtitle": "Invoiced revenue vs Real operating and driver costs",
        "topClientsTitle": "Top clients by revenue",
        "topClientsSubtitle": "Distribution of revenue and profitability by client",
        "additionalExpensesTitle": "Additional expenses by client",
        "additionalExpensesSubtitle": "Comparative breakdown of passed-on supplements vs non-passed supplements",
        "series": {
          "invoiceTransport": "Transport invoicing",
          "expensesRepercutidos": "Passed-on expenses",
          "totalCost": "Total cost",
          "expensesNoRepercutidos": "Non-passed expenses",
          "driverCost": "Driver + insurance cost",
          "invoicing": "Invoicing",
          "margin": "Margin",
          "transports": "Transports",
          "repercutidos": "Passed-on",
          "noRepercutidos": "Non-passed"
        }
      }
    },
    "client": {
      "kpis": {
        "totalSpent": "TOTAL SPENT",
        "totalSpentNote": "Transport + passed-on expenses",
        "averageTicket": "AVERAGE TICKET",
        "averageTicketNote": "Over filtered transports",
        "averageDistance": "AVERAGE DISTANCE",
        "averageDistanceNote": "Avg km per transport",
        "completedTransports": "TOTAL TRANSPORTS",
        "completedTransportsNote": "Period activity",
        "additionalExpenses": "ADDITIONAL EXPENSES",
        "additionalExpensesNote": "Passed-on expenses only",
        "cancellationCosts": "CANCELLATION COSTS",
        "cancellationRatio": "of created transports",
        "cancelledTransports": "CANCELLED TRIPS",
        "pendingIncidents": "PENDING INCIDENTS",
        "claims": "Claims",
        "breakdowns": "Breakdowns"
      },
      "charts": {
        "expensesSummaryTitle": "Expenses summary",
        "expensesSummarySubtitle": "Evolution of total spent and passed-on supplements volume",
        "series": {
          "totalAmount": "Total amount",
          "repercutidosCount": "Number of passed-on expenses",
          "repercutidosCountAxis": "Number of expenses",
          "supplements": "Number of supplements"
        }
      }
    }
  },
  "invoiceConceptType": {
    "TRANSPORT": "Transport",
    "FUEL": "Fuel",
    "FERRY": "Ferry",
    "CHARGING": "Charging",
    "ADDITIONAL_SERVICE": "Additional service",
    "ADDITIONAL_COST": "Additional cost",
    "ADJUSTMENT": "Adjustment",
    "BONUS": "Bonus",
    "PENALTY": "Penalty",
    "CANCELLATION": "Cancellation"
  },
  "common": {
    "email": "Email",
    "password": "Password",
    "login": "LOGIN",
    "remember_me": "Remember me",
    "forgot_password": "Forgot password?",
    "loading": "Loading...",
    "loading_dots": "loading ...",
    "filters": "FILTERS",
    "exportable": "EXPORT CSV",
    "textPlaceholder": "Type here...",
    "selectPlaceholder": "Select...",
    "back": "BACK",
    "newService": "NEW TRANSPORT",
    "cancel": "Cancel",
    "close": "Close",
    "copy": "Copy",
    "save": "Save",
    "accept": "Accept",
    "yes": "Yes",
    "no": "No",
    "guideLabel": "Format guide",
    "templateLabel": "Template file",
    "uploadLabel": "Import file",
    "actions": {
      "edit": "Edit",
      "view": "View",
      "delete": "Delete",
      "create": "Create",
      "save": "Save",
      "cancel": "Cancel"
    },
    "periodDays": {
      "15": "15 days",
      "30": "30 days",
      "45": "45 days",
      "60": "60 days",
      "75": "75 days",
      "90": "90 days"
    },
    "days": "days"
  },
  "paginator": {
    "itemsPerPageLabel": "Items per page:",
    "nextPageLabel": "Next page",
    "previousPageLabel": "Previous page",
    "firstPageLabel": "First page",
    "lastPageLabel": "Last page",
    "rangeLabel": {
      "empty": "0 of {{length}}",
      "range": "{{start}} - {{end}} of {{length}}"
    }
  },
  "cancellationAdjustmentType": {
    "PAY": "Pay driver",
    "PENALTY": "Penalize driver",
    "NO_PAY": "Don't pay driver"
  },
  "budgetStatus": {
    "ACCEPTED": "Accepted",
    "REJECTED": "Rejected",
    "PENDING": "Pending",
    "CANCELLED": "Cancelled",
    "UNASSIGNED": "Unassigned"
  },
  "login": {
    "title": "Sign In",
    "email_required": "Email is required",
    "email_invalid": "Invalid email format",
    "password_required": "Password is required",
    "password_min": "Password must be at least 6 characters",
    "signing_in": "Signing in...",
    "show_password": "Show password",
    "hide_password": "Hide password",
    "credentials_error": "Incorrect username or password",
    "connection_error": "Server connection error. Please try again later",
    "forgot_email_label": "Recovery email",
    "forgot_send": "SEND",
    "forgot_sending": "Sending...",
    "forgot_success": "A password reset email has been sent",
    "forgot_error": "Could not send the email. Please try again",
    "forgot_back": "Back to login",
    "reset_title": "Reset password",
    "reset_new_password": "New Password",
    "reset_confirm_password": "Confirm Password",
    "reset_hint": "At least 8 characters, 1 uppercase, 1 lowercase, 1 number and a symbol.",
    "reset_send": "SEND",
    "reset_sending": "Sending...",
    "reset_success": "Your password has been reset successfully",
    "reset_error": "Could not reset password. Please try again",
    "reset_password_required": "Password is required",
    "reset_password_pattern": "Password does not meet requirements",
    "reset_password_mismatch": "Passwords do not match"
  },
  "navigation": {
    "dashboard": "Dashboard",
    "users": "Users",
    "clients": "Clients",
    "client_group": "Client group",
    "clients_list": "Clients",
    "client_entity_users": "Entity users",
    "drivers": "Drivers",
    "transports": "Transports",
    "create_transport": "Create transport",
    "transport_assignment": "Transport assignment",
    "transport_history": "Transport management",
    "quality_info_management": "Quality info management",
    "drivers_incidents": "Drivers and incidents",
    "driver_regularizations": "Driver regularizations",
    "additional_expenses": "Additional expenses",
    "driver_invoice_emission": "Driver invoice emission",
    "driver_invoices": "Driver invoices",
    "client_invoices": "Client invoices",
    "invoices": "Billing",
    "notifications": "Notifications",
    "addresses": "Addresses"
  },
  "construction": {
    "title": "Page under construction"
  },
  "users": {
    "title": "Users",
    "profileTittle": "User Profile",
    "create-user": "Create new user",
    "edit-user": "Edit User",
    "profile": {
      "upload-photo": "UPLOAD PHOTO",
      "delete": "DELETE",
      "photo-upload-explanation": "Allows JPG, GIF or PNG. Max size 800Kb",
      "userName": "login user name",
      "username": "Username",
      "name": "Name",
      "lastname": "Last Name",
      "email": "Email",
      "password": "Password",
      "password-hint": "At least 8 characters, 1 uppercase, 1 lowercase, 1 number and a symbol.",
      "gen-pass": "GENERATE SECURE PASSWORD",
      "role": "Role",
      "status": "Status",
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "PENDING": "Pending",
      "SUSPENDED": "Suspended",
      "department": "Department",
      "USER": "User",
      "ADMIN": "Admin",
      "CLIENT_USER": "Client",
      "DRIVER": "Driver",
      "save-changes": "SAVE CHANGES",
      "cancel": "CANCEL",
      "SUPERADMIN": "Superadmin",
      "OPERATIONS_MANAGER": "Operations manager",
      "SALES_MANAGER": "Sales manager",
      "KAM": "KAM"
    },
    "list": {
      "photo": "Photo",
      "name": "Name",
      "lastname": "Last Name",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "department": "Department",
      "actions": "Actions",
      "searchPlaceholder": "Search",
      "filter": "Filters",
      "filters": "Filters",
      "create-user": "CREATE NEW USER",
      "advancedFilters": "Advanced Filters",
      "all": "All",
      "active": "Active",
      "inactive": "Inactive",
      "admin": "Administration",
      "hr": "Human Resources",
      "finance": "Finance",
      "dateFrom": "Date from",
      "dateTo": "Date to",
      "clearFilters": "Clear filters",
      "applyFilters": "Apply filters",
      "exportCSV": "Export CSV"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete"
    },
    "messages": {
      "delete_confirm": "Are you sure you want to delete this user?",
      "delete_success": "User deleted successfully",
      "delete_error": "Error deleting the user",
      "export_no_data": "No users to export",
      "export_success": "Users exported successfully",
      "export_error": "Error exporting the users"
    },
    "errors": {
      "password-weak": "Password is too weak",
      "password-invalid": "Password must have at least 8 characters, 1 uppercase, 1 lowercase, 1 number and a symbol.",
      "user-update-error": "Error updating user",
      "user-create-error": "Error creating user",
      "name-required": "Name is required",
      "lastname-required": "Last name is required",
      "email-invalid": "Invalid email",
      "image-required": "Image is required",
      "role-required": "You must select at least one role",
      "status-required": "You must select the status"
    },
    "success": {
      "user-updated": "User updated successfully",
      "user-created": "User created successfully"
    }
  },
  "clients": {
    "title": "Clients",
    "create-group-title": "Create Client Group",
    "edit-group-title": "Edit Client Group",
    "create-client-title": "Create/Edit Entity",
    "create-group": {
      "name": "Client group name",
      "country": "Country",
      "assigned-admins": "Assigned Administrators",
      "save": "Save changes",
      "cancel": "Cancel",
      "errors": {
        "name-required": "Name is required",
        "country-required": "Country is required"
      }
    },
    "create-client": {
      "upload-logo": "Upload Logo",
      "delete-logo": "Delete",
      "upload-logo-explanation": "Allows JPG, GIF or PNG. Max size 800Kb",
      "subentity": "Is subentity",
      "group": "Client Group",
      "name": "Name",
      "client": "Main Client",
      "entity": "Entity",
      "id-eurotransport": "Eurotransportcar ID (PO)",
      "id-revel": "Revel ID",
      "billing-type": "Billing Type",
      "billing-type-manual": "Manual",
      "billing-type-automatic": "Automatic",
      "send-manual-invoice": "Send manual invoice",
      "check-own-insurance": "Own insurance",
      "check-at-risk": "At risk",
      "appointment-time": "Waiting time to sent appointment (h) ",
      "appointment-time-between": "Time between appointments reminder (h)",
      "department-incidences": "Incidences department",
      "send-final-customer": "Send survey to final customer?",
      "client-type": "Client type",
      "client-type-1": "Type 1",
      "client-type-2": "Type 2",
      "client-origin": "Client origin",
      "client-origin-1": "Origin 1",
      "client-origin-2": "Origin 2",
      "main-contact": "Main contact",
      "main-contact-name": "Name",
      "main-contact-email": "Email",
      "main-contact-phone": "Phone",
      "email": "Email",
      "save-changes": "Save changes",
      "cancel": "Cancel",
      "contact-gral": "General contacts",
      "internal-protocol": "Internal protocol",
      "contacts-requireds": "Both fields are required",
      "errors": {
        "name-required": "Name is required",
        "id-eurotransport-required": "Eurotransportcar ID is required",
        "id-revel-required": "Revel ID is required",
        "billing-type-required": "Billing type is required",
        "client-type-required": "Client type is required",
        "client-origin-required": "Client origin is required"
      },
      "movement-type": "Movement type",
      "movement-type-1": "Movement 1",
      "movement-type-2": "Movement 2",
      "adjunt-type": "Adjunt type",
      "adjunt-type-1": "Adjunt 1",
      "adjunt-type-2": "Adjunt 2",
      "application-moment": "Application moment",
      "application-moment-1": "Application 1",
      "application-moment-2": "Application 2",
      "main-client": "Main client",
      "save": "Save",
      "doc_type": "Doc type",
      "doc-type-1": "Doc 1",
      "doc-type-2": "Doc 2",
      "url": "URL",
      "archive-link": "Archive link",
      "entity-reference": "Entity reference",
      "document-type": "Document type",
      "document-code": "Document Nº",
      "retention": "Retention",
      "company-name": "Company name",
      "vat-type": "VAT type",
      "billing-address": "Billing address",
      "address-complement": "Address complement",
      "postal-code": "Postal code",
      "city": "City",
      "country": "Country",
      "eurotransportcar-identifier": "Eurotransportcar identifier",
      "revel-identifier": "Revel identifier",
      "accounting-email": "Accounting email",
      "accounting-email-placeholder": "Type an email and press Enter...",
      "accounting-phone": "Accounting phone",
      "mark-as-favorite": "Mark as favorite",
      "due-period": "Due period",
      "add-account": "ADD ACCOUNT",
      "id-ref": "ID REF.",
      "tax-id-dni": "TAX ID OR DNI",
      "retention-percent": "RETENTION (%)",
      "actions": "ACTIONS",
      "results-per-page": "Results per page",
      "cif": "CIF",
      "department": "Department",
      "fuel": "Fuel",
      "included-fuel": "Fuel included",
      "client-price": "Client price",
      "driver-price": "Driver price % per Km",
      "ferry": "Ferry",
      "ferry-price": "Ferry price",
      "ev": "Electric vehicle",
      "ev-client-price": "Client price per Km (EUR)",
      "ev-driver-price": "Driver price per Km (EUR)",
      "additional": "Additional",
      "express-transport-percent": "Express transport price (%)",
      "stage-discount-percent": "Per extra stage discount (%)",
      "km-bands": "Kilometer bands",
      "km-from": "From (Km)",
      "km-to": "To (Km)",
      "price-to-client": "Price to client",
      "price-type": "Price type",
      "standard-price-eur": "Standard price (EUR)",
      "price-vu-lt-12": "Price VU < 12m3",
      "price-vu-gt-12": "Price VU > 12m3",
      "distance-interval": "Distance interval",
      "validate-add": "Validate and add",
      "save-price": "Save price data",
      "save-prices-first": "Save the price data before creating kilometer bands",
      "km-overlap-error": "Km ranges cannot overlap, without undefined ranges in between and the first must start at 0",
      "price_rules_saved_success": "Price rules saved successfully",
      "doc-type": "Document type",
      "cert_list": "Cert list",
      "certs-created": "Certs created list",
      "certs-assigned": "Certs assigned",
      "delete-certification-confirmation": "Are you sure you want to delete this certification?",
      "choose-certification": "Choose certification",
      "certification-title": "Certification title",
      "cert-question": "Question",
      "question-placeholder": "Write your question here?",
      "answer": "Answer",
      "answer-placeholder": "Write the answer here",
      "add-answer": "Add answer",
      "add-question": "Add question",
      "config": "Config",
      "attempts-per-week": "Attempts per week",
      "available-new-drivers": "Available for new drivers",
      "save-cert": "Save certification",
      "action-details": "Action details",
      "action-title": "Action title",
      "driver-payment": "Driver payment",
      "departure": "Departure",
      "arrival": "Arrival",
      "both": "Both (Departure and Arrival)",
      "certification-config": "Certification configuration",
      "certification-name": "Name",
      "edit-certification": "EDIT CERTIFICATION",
      "select-certification": "SELECT A CERTIFICATION",
      "requires-certification": "Requires certification",
      "selected-by-default": "Selected by default",
      "visible-to-driver": "Visible for the driver",
      "requires-image-location": "Requires image and location",
      "requires-appoinment": "Appointment required",
      "assign": "ASSIGN",
      "protocolo-save": "Save protocol",
      "protocol-delete-confirm-title": "Delete protocol?",
      "protocol-delete-confirm-subtitle": "This action cannot be undone. The protocol will be permanently deleted.",
      "protocols-assigned": "Protocols assigned",
      "protocols-templates": "Protocols templates",
      "intern-movement-type": "Intern movement type",
      "schemas": "Schemas",
      "protocols": "Protocols",
      "type": "Type",
      "edit-options": "Edit options",
      "client-process": "Client process",
      "simple-movement": "Simple movement",
      "pickup-to-final-customer": "Pickup to final customer",
      "delivery-to-final-customer": "Delivery to final customer",
      "pickup-and-delivery-to-final-customer": "Pickup and delivery to final customer",
      "with-stopover": "With stopover",
      "single-check": "Single check",
      "multi-check": "Multi check",
      "image": "Image",
      "both-departure-both": "Both (departure and arrival)",
      "pricing-type-fixed": "Fixed",
      "pricing-type-per-km": "Per kilometer",
      "description": "Description",
      "additional-services": "Additional services templates",
      "additional-services-assigned": "Additional services assigned",
      "other": "Other"
    },
    "list": {
      "clients_group": "Client Groups",
      "clients_list": "Client List",
      "group_name": "Group Name",
      "logo": "Logo",
      "name": "Name",
      "group": "Group",
      "cif": "CIF",
      "registration_date": "Registration Date",
      "department-name": "Department",
      "country-name": "Country",
      "tags": "Tags",
      "entity": "Entity",
      "actions": "Actions",
      "searchPlaceholder": "Search...",
      "create-client": "CREATE NEW CLIENT",
      "create-group": "CREATE NEW GROUP",
      "group_filter": "Group",
      "cif_filter": "CIF",
      "cif_placeholder": "Type here...",
      "registration_date_filter": "Registration date",
      "department_filter": "Department",
      "tags_filter": "Tags",
      "entity_filter": "Entity",
      "subentity_filter": "Subentity",
      "users_assigned": "Users Assigned",
      "country_filter": "Country",
      "users_assigned_filter": "User",
      "country": {
        "ES": "Spain",
        "FR": "France",
        "PT": "Portugal",
        "IT": "Italy",
        "DE": "Germany",
        "UK": "United Kingdom",
        "NL": "Netherlands",
        "BE": "Belgium",
        "CH": "Switzerland",
        "AT": "Austria"
      },
      "department": {
        "IT": "Technology",
        "HR": "Human Resources",
        "Finance": "Finance",
        "Operations": "Operations",
        "Sales": "Sales",
        "Marketing": "Marketing"
      }
    },
    "messages": {
      "delete_group_confirm": "Are you sure you want to delete this client group?",
      "delete_group_success": "Client group deleted successfully",
      "delete_group_error": "Error deleting client group",
      "group_saved_success": "Group saved successfully",
      "save_group_error_title": "Error",
      "save_group_error": "The client group could not be saved",
      "delete_client_confirm": "Are you sure you want to delete this client?",
      "delete_client_success": "Client deleted successfully",
      "delete_client_error": "Error deleting client",
      "delete_client_error_title": "Error",
      "delete_client_not_implemented": "Client deletion is not currently available",
      "save_billing_error": "Error saving billing account",
      "load_billing_error": "Error loading billing account",
      "export_no_data": "No data to export",
      "export_error": "Error exporting clients",
      "export_groups_error": "Error exporting client groups"
    },
    "import": {
      "template_button": "IMPORT TEMPLATE",
      "import_button": "IMPORT EXCEL",
      "info_button": "Import guide",
      "success": "Import completed successfully",
      "error_title": "Import error",
      "no_records": "No records found to import",
      "rows_failed": "The following rows could not be imported: {{rows}}",
      "success_count": "{{count}} entities have been created",
      "server_error": "Server error while importing data"
    },
    "billing_import": {
      "template_button": "IMPORT TEMPLATE",
      "import_button": "IMPORT EXCEL",
      "info_button": "Billing accounts import guide",
      "success": "Billing accounts import completed successfully",
      "error_title": "Billing accounts import error",
      "template_filename": "billing_accounts_import_template.xlsx",
      "id_mismatch": "The current client ID is {{id}} and some records do not match",
      "rows_failed": "The following rows could not be imported: {{rows}}",
      "success_count": "A total of {{count}} rows have been imported",
      "format_error": "Incorrect file format",
      "server_error": "Server error while importing billing accounts"
    }
  },
  "tabs": {
    "groups": "Client Groups",
    "list": "Clients List",
    "general": "General information",
    "protocol": "Protocol",
    "slogans": "Driver slogans",
    "documents": "Documents",
    "extra-contact": "Contact",
    "billing": "Billing",
    "prices": "Prices",
    "certs": "Certs",
    "additional-services": "Additional Services",
    "assignment": "Transport assignments",
    "history": "Transport management",
    "general-data": "General Data",
    "quality": "Quality",
    "certifications": "Certifications",
    "blacklist": "Blacklist",
    "documentation": "Documentation",
    "timeline": "Timeline",
    "authorized": "Authorized",
    "quality-report": "Quality report",
    "mission-start": "Mission start",
    "mission-mid": "Mission mid",
    "mission-end": "Mission end",
    "survey": "Survey",
    "budget-list": "Budget list",
    "notifications": "Notifications",
    "manual-assignment": "Manual assignment",
    "incident-management": "Incident management",
    "metrics": "Metrics"
  },
  "transports": {
    "title": "Transports",
    "modify_transport": "Modify Transport",
    "survey": {
      "title": "Customer satisfaction survey",
      "pickup_survey": "Pickup survey",
      "delivery_survey": "Delivery survey",
      "no_answers": "No survey answers registered for this phase.",
      "no_comment_provided": "No additional comments",
      "question": "Question",
      "answer": "Answer"
    },
    "budget-over-transport": {
      "title": "Transport budgets",
      "id": "Transport ID: "
    },
    "fast_edit": {
      "user_assigned": "Assigned user",
      "visible_budget": "Visible budget",
      "transport_premium": "Premium transport",
      "center_invoice": "Billing center",
      "tags": "Tags",
      "start_date": "Start date",
      "start_hour_start_date": "Start time (departure)",
      "end_hour_start_date": "End time (departure)",
      "end_date": "End date",
      "start_hour_end_date": "Start time (arrival)",
      "end_hour_end_date": "End time (arrival)",
      "enroll": "License plate",
      "send_secure": "Secure send",
      "customer_price": "Customer price",
      "number_ref": "Reference number",
      "comments": "Comments",
      "comments_placeholder": "Write your comments here..."
    },
    "list": {
      "movement_type_filter": "Movement Type"
    },
    "create": {
      "back": "Back",
      "not-assigned": "Not assigned",
      "title": "New Transport",
      "client-user": "Client user",
      "client-user-assigned": "Client user assigned",
      "manager": "Manager",
      "panel-user-assigned": "Internal user assigned",
      "budget-visible": "Budget visible",
      "premium-transport": "Premium transport",
      "transport-type": "Transport type",
      "simple-movement": "Simple movement",
      "pickup-to-final-customer": "Pickup to final customer",
      "delivery-to-final-customer": "Delivery to final customer",
      "pickup-and-delivery-to-final-customer": "Pickup and delivery to final customer",
      "with-stopover": "Movement with stopover (itv, workshop, etc.)",
      "continue": "Continue",
      "cancel": "Cancel",
      "billing-center": "Billing center",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "pickup-address": "Departure address and contact",
      "delivery-address": "Delivery address and contact",
      "schedule": "Schedule",
      "departure": "Departure",
      "arrival": "Arrival",
      "available-from": "Available from",
      "available-to": "Deliver before",
      "from": "From",
      "to": "To",
      "min-time-range": "Time ranges must be at least two hours.",
      "date-required": "You must select pickup and delivery dates to save.",
      "add-delivery": "Add delivery",
      "add-stage": "Add stage",
      "remove-stage-title": "Remove stage?",
      "remove-stage-subtitle": "The third stage of the transport will be removed and you will lose the entered data.",
      "vehicles": "Vehicle",
      "import-csv": "Import CSV",
      "complementary-services-added": "Additionals services added",
      "plate-search": "Search the plate to add vehicle",
      "add-vehicle": "Add other vehicle",
      "cleaning-service": "Cleaning service",
      "demostration-service": "Vehicle demonstration",
      "revision-service": "Technical revision",
      "complementary-services": "Additionals services",
      "no-complementary-services": "No additionals services available",
      "added": "Added",
      "required-documents": "Documents",
      "add": "Add",
      "comments-reference": "Comments and reference",
      "reference-number": "Reference number",
      "comments": "Comments",
      "publish-transport": "Publish transport",
      "cancel-transport": "Cancel transport",
      "save": "Save",
      "address-search-placeholder": "Type here...",
      "add-new-address": "ADD NEW ADDRESS",
      "add-new-address-modal-title": "New address",
      "pickup-address-hint": "Write manually or search in your favorites",
      "add-address": "Add address",
      "name": "Name",
      "address-type": "Address type",
      "country": "Country",
      "province": "Province",
      "city": "City",
      "postal-code": "Postal code",
      "full-address": "Full address",
      "address-complement": "Address complement",
      "address-data": "Address data",
      "contacts": "Contacts",
      "phone": "Phone",
      "email": "Email",
      "additional-contact-phones": "Additional contact phones",
      "additional-contact-emails": "Additional contact emails",
      "add-another": "+ ADD ANOTHER",
      "overwrite-associated-contact": "Overwrite associated contact",
      "declare-opening-hours": "Declare opening hours",
      "schedules": "Schedules",
      "opening-hours": "Opening hours",
      "time-slot": "Time slot",
      "add-time-slot": "ADD TIME SLOT",
      "schedule-label": "Schedule:",
      "contact": "Contact",
      "additional-contacts": "Additional contacts",
      "transport-not-found": "Transport not found",
      "stopover": "Stage",
      "stop": "Stop",
      "license-plate": "License plate",
      "license-plate-required": "License plate is required",
      "plate-not-found-title": "License plate not found",
      "plate-not-found-manual-confirm": "The license plate was not found in the system. Do you want to enter the vehicle details manually?",
      "brand": "Brand",
      "model": "Model",
      "vehicle-type": "Vehicle type",
      "fuel-type": "Fuel type",
      "documents-pickup-ab": "Pickup documents A → B",
      "documents-delivery-ab": "Delivery documents A → B",
      "documents-pickup-bc": "Pickup documents B → C",
      "documents-delivery-bc": "Delivery documents B → C",
      "appointment-pickup-hint": "The end customer will select the pickup date and slot via appointment.",
      "appointment-delivery-hint": "The end customer will select the delivery date and slot via appointment.",
      "appointment-dual-hint": "Pickup and delivery appointments will be scheduled directly by the administrator."
    },
    "edit": {
      "title": "Edit Transport"
    },
    "details": {
      "documents": {
        "required-title": "Required transport documentation",
        "driver-title": "Documentation uploaded by the driver",
        "roadit-title": "Documentation uploaded by Roadit"
      }
    },
    "select-create": {
      "add-address": "Add address"
    },
    "schedule-modal": {
      "time-range-error": "Start time must be before end time",
      "chronological-error": "Dates and times must be in chronological order: pickup, stopover (if exists), and delivery",
      "min-time-error": "Pickup time must be at least 15 minutes from now",
      "holidays": "Holidays",
      "address-required": "Select pickup and delivery addresses before scheduling dates",
      "holiday-warning-title": "Holiday selected",
      "holiday-warning-message": "The day {{date}} is a holiday in {{location}}, please ensure the pickup or delivery of the vehicle is guaranteed, otherwise you will be responsible for the corresponding costs."
    },
    "assignments": {
      "id": "ID",
      "reference": "Reference",
      "client_sub": "Entity/Sub",
      "movement": "Movement",
      "date_time": "Date/Time",
      "client_price": "Client Price",
      "best_price": "Best Budget",
      "appointment": "Appointment",
      "tags": "Tags",
      "km_duration": "Km/Duration",
      "departure_arrival": "departure/arrival",
      "budget_number": "Budget #",
      "responsible": "Responsible",
      "actions": "Actions",
      "searchPlaceholder": "Search assignments...",
      "reference_filter": "Reference #",
      "transport_number_filter": "Transport #",
      "reservation_number_filter": "Reservation #",
      "creation_date_filter": "Creation Date",
      "departure_province_filter": "Departure Province",
      "arrival_province_filter": "Arrival Province",
      "email_filter": "Email",
      "date_range_filter": "Start/End",
      "movement_type_filter": "Movement Type",
      "tags_filter": "Tags",
      "entity_filter": "Entity",
      "subentity_filter": "Subentity",
      "create_transport": "Create Transport",
      "start_date": "Start date",
      "end_date": "End date",
      "lock_action": "Lock",
      "menu_action": "More options",
      "driver": "Driver",
      "fortnight_earnings": "Fortnight Earnings",
      "score": "Score",
      "status": "Status",
      "budget": "Budget",
      "margin": "Margin",
      "date_time_driver": "Date/Time Driver",
      "simulaneous_missions": "Simultaneous Missions",
      "mission_id_button": "Mission ID",
      "reject_selected": "Reject selected",
      "manage_appointment": "Manage appointment",
      "budget-details": "Budget breakdown",
      "budget-detailDrvier": "Driver contact",
      "base-price": "Base price",
      "fuel-price": "Fuel",
      "ferry-cost": "Ferry",
      "toll-expense": "Tolls",
      "optional-expenses": "Optional expenses",
      "outbound-cost": "Outbound cost",
      "return-cost": "Return cost",
      "margin-eur": "Margin (EUR)",
      "total-price": "Total price"
    },
    "history": {
      "id": "ID",
      "reference": "Reference",
      "client_sub": "Entity/Sub",
      "movement": "Movement",
      "date_time": "Date/Time",
      "status": "Status",
      "price": "Price",
      "date_range": "Date/Time",
      "tags": "Tags",
      "responsible": "Responsible",
      "duration": "Km/Duration",
      "admin": "Manager",
      "actions": "Actions",
      "searchPlaceholder": "Search history...",
      "reference_filter": "Reference #",
      "client_filter": "Entity/Sub",
      "status_filter": "Status",
      "date_range_filter": "Start/End",
      "tags_filter": "Tags",
      "driver": "Driver",
      "duration_filter": "Duration",
      "admin_filter": "Admin",
      "actions_filter": "Actions",
      "hours": "hours",
      "origin_province": "Origin Province",
      "destination_province": "Destination Province",
      "driver_email": "Driver Email",
      "entity": "Entity",
      "subentity": "Subentity",
      "visible": "Visible",
      "appointment_required": "Appointment Management Required",
      "create": "CREATE NEW TRANSPORT",
      "actions_column": {
        "lock": "Lock",
        "unlock": "Unlock",
        "calendar": "Manage appointment",
        "hand": "More options",
        "visibility": "View details",
        "folder": "Transport summary",
        "calendar_pending": "Pending appointment to book",
        "calendar_booked": "Appointment booked",
        "calendar_expired": "Manage appointment (transport expired)"
      },
      "options": {
        "title": "Modify transport history data",
        "summary": "Transport summary",
        "modify": "Modify transport",
        "modify_plate": "Modify license plate",
        "modify_price": "Modify client billing price",
        "add_return": "Add return",
        "manage_reservation": "Manage reservation",
        "unassigned_drivers": "Unassigned drivers",
        "regularizations": "Regularizations",
        "add_quality_incident": "Add quality incident",
        "duplicate": "Duplicate transport",
        "cancel": "Cancel transport / Manage cancellation",
        "delete": "Delete transport",
        "timeline": "Transport timeline",
        "budget_history": "Budget history"
      },
      "success": {
        "transport_blocked": "Transport blocked successfully",
        "transport_unblocked": "Transport unblocked successfully"
      },
      "errors": {
        "transport_id_not_found": "Could not identify the transport",
        "cannot_block_in_course": "Cannot block a transport that is in course",
        "block_operation_failed": "Error blocking/unblocking the transport"
      },
      "pending_appointments_badge": "transports require appointment management",
      "filter_pending_tooltip": "Filter by transports pending appointment booking",
      "filter_pending_active_tooltip": "Clear pending appointment booking filter"
    },
    "cancel": {
      "title": "Cancel transport",
      "cancelledBy": "Who cancelled",
      "cancelledByOptions": {
        "admin": "Administrator",
        "client": "Client"
      },
      "reason": "Reason",
      "comment": "Comment",
      "driverAction": "Driver action",
      "clientAction": "Client action",
      "payDriver": "Pay driver",
      "penalizeDriver": "Penalize driver",
      "dontPayDriver": "Don't pay driver",
      "selectOptions": "Select options",
      "manualEntry": "Manual entry",
      "amount": "Amount",
      "less24h": "Less than 24 hours (100%)",
      "between24_48h": "Between 24 and 48 hours (50%)",
      "customPercentage": "Custom %",
      "percent": "Enter percentage",
      "mone": "Enter amount",
      "percentagePlaceholder": "Enter a percentage (0-100)",
      "cancelButton": "CANCEL TRANSPORT",
      "clientOptions": {
        "less_24h": "Less than 24 hours (100%)",
        "24_48h": "Between 24 and 48 hours (50%)",
        "more_48h": "More than 48 hours (0%)"
      },
      "errors": {
        "cancelledByRequired": "You must select who cancelled the transport.",
        "reasonRequired": "You must select a reason for the cancellation.",
        "messageRequired": "The reason comment is mandatory.",
        "negativeDriverPrice": "The driver amount cannot be negative.",
        "negativeClientPercentage": "The client percentage cannot be negative.",
        "invalidDriverActionForRole": "The driver action is not valid for the cancelling actor.",
        "invalidClientActionForRole": "The client action is not valid for the cancelling actor.",
        "invalidDriverPercent": "The driver percentage cannot exceed 100%."
      },
      "success": "Transport cancelled correctly"
    },
    "unassign": {
      "errors": {
        "fetch_failed": "Error fetching unassignment information"
      }
    },
    "manage_reservation": {
      "title": "Manage reservation",
      "prestacion": "Service",
      "transporte_hacia_recogida": "Transport to pickup",
      "transporte_desde_entrega": "Transport from delivery",
      "peajes": "Tolls",
      "gastos_excepcionales": "Exceptional expenses",
      "ferry": "Ferry",
      "combustible": "Fuel",
      "carga_vehiculo_electrico": "Electric vehicle charge",
      "save": "SAVE",
      "cancel_reservation": "REMOVE RESERVATION",
      "write_here": "Write here...",
      "loading": "Loading reservation data..."
    },
    "timeline": {
      "title": "View transport timeline",
      "modified_by": "modified by",
      "view_ticket_details": "View ticket details",
      "loading": "Loading timeline...",
      "no_events": "No events in timeline"
    },
    "edit_appointment": {
      "title": "Edit final client appointment",
      "client_date": "Add date",
      "pickup_time": "Final client pickup time",
      "delivery_time": "Final client delivery time",
      "from": "From:",
      "to": "To:",
      "no_services_message": "This transport does not have delivery or pickup service",
      "transport_not_found": "Transport not found.",
      "client_not_found": "Could not find transport client",
      "load_error": "Error loading appointment data.",
      "client_availability_title": "Final customers date availability",
      "add_date": "Add date",
      "pickup_time_title": "Pickup schedule",
      "delivery_time_title": "Delivery schedule",
      "date_required": "You must select a date to book the appointment.",
      "save_success": "Appointment saved successfully.",
      "save_error": "Error saving appointment.",
      "driver_conflict": "Cannot modify appointment because a driver is already assigned to this transport. You must unassign the driver before updating the appointment.",
      "pickup_appointment_title": "Final customer pickup appointment",
      "delivery_appointment_title": "Final customer delivery appointment",
      "pickup_date": "Pickup date",
      "delivery_date": "Delivery date",
      "pickup_date_required": "You must select a pickup date to book the appointment.",
      "delivery_date_required": "You must select a delivery date to book the appointment.",
      "field_required": "This field is required.",
      "date_out_of_range": "The selected date is outside the allowed range.",
      "invalid_time_range": "End time must be after start time.",
      "delivery_before_pickup": "Delivery date and time cannot be prior to pickup.",
      "past_pickup_datetime": "Pickup date and time cannot be prior to the current moment.",
      "past_delivery_datetime": "Delivery date and time cannot be prior to the current moment.",
      "resend_success": "Appointment email resent successfully.",
      "resend_error": "Error resending appointment email.",
      "pending_customer_info": "This appointment is pending booking by the end customer via the emailed link.",
      "resend_button": "Resend email",
      "resending": "Resending...",
      "last_sent_at": "Last sent:",
      "client_email": "Customer email:",
      "no_email_warning": "No contact email address is configured.",
      "manual_override_checkbox": "Book appointment manually as administrator",
      "readonly_driver_warning": "Read-only mode: appointment cannot be modified because the transport has an assigned driver.",
      "readonly_expired_warning": "Read-only mode: this appointment has expired and cannot be modified.",
      "no_active_appointments": "This transport has an appointment management service, but was registered prior to the activation of the digital appointment system. For this reason, it has no active appointment linked on the server."
    },
    "retrieve": {
      "assigned-to": "Assigned to",
      "stopover": "Stopover",
      "appointment-management": "Appointment management",
      "related-transport": "Related transport",
      "hide-general-info": "Hide general info",
      "show-general-info": "Show general info",
      "download-mission-data": "Download mission data",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "stage": "Stage",
      "contact-person": "Contact person",
      "schedule": "Schedule",
      "additional-contacts": "Additional contacts",
      "pickup-availability": "Pickup date and time availability",
      "delivery-availability": "Delivery date and time availability",
      "stage-availability": "Stage date and time",
      "availability-range": "From {{from}} to {{to}}",
      "vehicle": "Vehicle",
      "complementary-services": "Additionals services",
      "no-complementary-services": "No additionals services",
      "comments-reference": "Comments and reference",
      "reference-number": "Reference number",
      "comments": "Comments",
      "no-comments": "No comments",
      "driver": "Driver",
      "no-driver-assigned": "The transport does not yet have an assigned driver",
      "full-name": "Full name",
      "email": "Email",
      "dni": "ID",
      "phone": "Phone",
      "close": "Close"
    },
    "quality-report": {
      "add-incident": "Add quality incident",
      "col_type": "Type",
      "col_reason": "Reason",
      "col_entity": "ENTITY/SUB",
      "col_created_date": "Created date",
      "col_driver": "Driver",
      "col_status": "Status",
      "col_responsible": "Responsible",
      "col_actions": "Actions",
      "responsible_admin": "Administrator",
      "responsible_client": "Client"
    },
    "incident-form": {
      "errors": {
        "no-drivers-assigned": "There are no drivers assigned to the transport"
      },
      "title": "Register a quality incident",
      "description": "Tell us what happened in this transport. We will collect the necessary information to review it and give you a solution.",
      "emergency": "For an ongoing emergency, contact us at (+34) ...",
      "start": "START",
      "step2": {
        "title": "Information",
        "freshdesk-client": "Freshdesk link for client",
        "freshdesk-driver": "Freshdesk link for driver",
        "select-driver": "Select driver",
        "back": "BACK",
        "cancel": "CANCEL",
        "next": "NEXT"
      },
      "step3": {
        "title": "Incident type",
        "main-type": "Reasons",
        "subtype": "Sub-reason",
        "loading-subtypes": "Loading subtypes...",
        "quantity": "Quantity",
        "quantity-hours-placeholder": "Enter hours...",
        "quantity-km-placeholder": "Enter kilometers...",
        "quantity-liters-placeholder": "Enter liters...",
        "quantity-amount-placeholder": "Enter amount...",
        "back": "BACK",
        "cancel": "CANCEL",
        "next": "NEXT"
      },
      "step4": {
        "title": "Details*",
        "description": "Describe what happened so we can review it (minimum 10 characters)",
        "placeholder": "Write here...",
        "back": "BACK",
        "cancel": "CANCEL",
        "next": "NEXT"
      },
      "step5": {
        "title": "Attach files",
        "description": "You can add images, videos or documents that help review this incident.",
        "add-file": "ADD",
        "no-files": "No attached files",
        "download": "Download",
        "delete": "Delete",
        "back": "BACK",
        "cancel": "CANCEL",
        "next": "SEND"
      },
      "success": {
        "title": "Incident registered",
        "message": "Thank you very much for helping us improve. We will review the reported incident in detail and keep you informed",
        "close": "CLOSE"
      },
      "driver": {
        "asigned": "Assigned to the route"
      }
    },
    "budgets": {
      "driver_earnings": "Fortnight earnings",
      "accept": "Accept",
      "reject": "Reject",
      "rejected": "REJECTED",
      "accepted": "ACCEPTED",
      "confirm_accept_title": "Are you sure you want to accept the budget?",
      "confirm_accept_message": "The driver has other simultaneous missions",
      "confirm_reject_title": "Are you sure you want to reject the budget?",
      "confirm_reject_selected_title": "Are you sure you want to reject the budgets?",
      "no_selected_title": "No budgets selected",
      "no_selected_message": "Select at least one budget to reject",
      "no_pending_title": "No pending budgets",
      "no_pending_message": "The selected budgets have already been processed",
      "accept_success": "Budget accepted successfully",
      "accept_error": "Error accepting the budget",
      "reject_success": "Budget rejected successfully",
      "reject_error": "Error rejecting the budget",
      "reject_selected_success": "Budgets rejected successfully",
      "reject_selected_error": "Error rejecting the budgets",
      "show_top_10": "Show TOP 10 budgets",
      "breakdown": {
        "base_price": "Base price",
        "fuel_price": "Fuel",
        "transport_cost_outbound": "Outbound transport",
        "transport_cost_return": "Return transport",
        "optional_expenses": "Optional expenses",
        "accommodation_cost": "Accommodation",
        "toll_expense": "Tolls",
        "per_diem_cost": "Per diem"
      },
      "message_label": "Message",
      "optional": "optional",
      "message_placeholder_accept": "Write a message for the driver (optional)...",
      "message_placeholder_reject": "Write the rejection reason (optional)...",
      "selected_count": "Selected budgets",
      "confirm_title": "Confirmation",
      "departure_arrival": "Departure / Arrival"
    },
    "notifications": {
      "city": "City",
      "driver": "Driver",
      "email": "Email",
      "score": "Score",
      "budget": "Budget",
      "compatibility": "Compatibility",
      "simultaneous_missions": "Simultaneous missions",
      "budget-in-transport": "Budget in transport",
      "compatible-drivers": "Compatible drivers",
      "has-other-transports": "Has other transports",
      "driver-score": "Driver score",
      "rating-min": "Min score",
      "rating-max": "Max score",
      "both": "Both",
      "send-notification": "Send notification",
      "send_modal": {
        "title": "Send notifications",
        "title_label": "Title",
        "title_placeholder": "Write the title...",
        "message_label": "Message",
        "message_placeholder": "Write here...",
        "send_by_label": "Send by",
        "push": "PUSH Notification",
        "email": "Email",
        "send_button": "SEND NOTIFICATIONS",
        "sending": "SENDING...",
        "success": "Notifications sent successfully.",
        "error": "Error sending notifications.",
        "no_selection": "No drivers selected",
        "no_selection_subtitle": "Select at least one driver from the table to send notifications.",
        "no_emails": "Selected drivers have no email"
      }
    },
    "messages": {
      "duplicate-vehicle-error": "A vehicle with that license plate already exists in the transport.",
      "delete-document-confirm": "Are you sure you want to delete this document?",
      "publish-success": "Transport published successfully.",
      "update-success": "Transport updated successfully",
      "execeded-kilometres": "The client does not have prices defined for the route kilometers",
      "validation-error-prefix": "The transport is not valid:",
      "validation-admin-required": "The transport must have an assigned administrator.",
      "validation-billing-required": "The transport must have an assigned billing account.",
      "validation-vehicle-required": "The transport must have at least one assigned vehicle.",
      "validation-origin-address-required": "The transport must have a pickup address at each stage.",
      "validation-destination-address-required": "The transport must have a delivery address at each stage.",
      "validation-leg-required": "The transport must have at least one stage.",
      "validation-departure-date-required": "The transport must have a pickup date.",
      "validation-arrival-date-required": "The transport must have a delivery date.",
      "validation-reference-required": "The transport must have a reference number.",
      "publish-error": "Server error while saving transport",
      "manual-price-minor": "The manual price is less than the calculated price",
      "validation-total-time-short": "The time interval between pickup and delivery is less than the estimated trip duration."
    },
    "manual-assign": {
      "searchPlaceholder": "Search driver...",
      "full-name": "Full name",
      "dni": "ID",
      "driver-score": "Driver score",
      "fortnight-earnings": "Fortnight earnings",
      "no-driver-selected": "No driver selected",
      "margin": "Margin",
      "createBudget": "Create budget",
      "outbound": "Outbound",
      "return": "Return",
      "service": "Service",
      "transportToPickup": "Transport to pickup",
      "transportFromDelivery": "Transport from delivery",
      "additionalCosts": "Additional costs",
      "tolls": "Tolls",
      "exceptionalExpenses": "Exceptional expenses",
      "ferry": "Ferry",
      "electricVehicleCharge": "Electric vehicle charge",
      "fuel": "Fuel",
      "dateAndTime": "Date and time",
      "addDate": "Pickup date",
      "deliveryDate": "Delivery date",
      "pickup": "Pickup",
      "delivery": "Delivery",
      "assignMission": "ASSIGN MISSION",
      "appointment_booked_info": "Date and schedule fixed by agreed appointment with the final customer.",
      "appointment_pending_info": "This leg requires appointment management and is pending booking.",
      "errors": {
        "prestacion": "Service is mandatory",
        "transporteRecogida": "Transport to pickup is mandatory",
        "transporteEntrega": "Transport from delivery is mandatory",
        "fecha": "Date is mandatory",
        "horaRecogida": "Pickup time is mandatory",
        "horaEntrega": "Delivery time is mandatory",
        "outOfDate": "The date is not within the acceptable range",
        "appointmentPending": "Cannot assign a driver while the appointment is pending booking."
      }
    },
    "mission": {
      "control_panel": "Control Panel",
      "movement_protocols": "Movement Protocols",
      "inspection_photos": "Inspection Photos",
      "exterior_photos": "Exterior Photos",
      "interior_photos": "Interior Photos",
      "exit_anomalies": "Exit Anomalies",
      "delivery_anomalies": "Delivery Anomalies",
      "budgeted": "Budgeted:",
      "real": "Real:",
      "photo_signature": "Photo and Signature",
      "delivery_signatures": "Delivery Signatures",
      "driver_signature": "Driver Signature",
      "professional_driver": "Professional Driver",
      "exit_client": "Exit Client",
      "delivery_contact": "Delivery Contact",
      "fuel_amount": "Fuel Amount",
      "amount_km": "Amount in Km",
      "keys_label": "Keys (total delivered keys)",
      "charging_cables": "Charging Cables",
      "registration_certificate": "Registration Certificate",
      "technical_sheet": "Technical Sheet",
      "spare_wheel": "Spare Wheel / Puncture Kit",
      "reflective_vest": "Reflective Vest (optional)",
      "v16_beacom": "V16 Beacon (optional)",
      "km": "Km",
      "km_diff_pickup_address": "Km difference with pickup address",
      "km_diff_delivery_address": "Km difference with delivery address",
      "no_protocols": "Sin protocolos relacionados",
      "no_anomalies": "Sin anomalías de salida",
      "no_services": "Sin servicios complementarios",
      "no_exterior_photos": "Sin fotos de exterior",
      "no_interior_photos": "Sin fotos de interior",
      "pickup_address": "Pickup Address",
      "delivery_address": "Delivery Address",
      "geolocation_pickup_preparation": "Pickup Preparation Geolocation",
      "geolocation_delivery_preparation": "Delivery Preparation Geolocation",
      "geolocation_pickup_send": "Pickup Send Geolocation",
      "geolocation_delivery_send": "Delivery Send Geolocation",
      "pickup_datetime": "Pickup Date and Time",
      "delivery_datetime": "Delivery Date and Time"
    }
  },
  "notifications": {
    "title": "Notifications",
    "create": "Create notification",
    "searchPlaceholder": "Search...",
    "list": {
      "searchPlaceholder": "Search"
    },
    "send-notification": "Send notification",
    "columns": {
      "title": "Title",
      "message": "Message",
      "send_to": "Send to",
      "target": "Recipients",
      "status": "Status",
      "scheduled": "Scheduled",
      "specific_users": "Specific users",
      "actions": "Actions"
    },
    "actions": {
      "resend": "resend",
      "view": "View",
      "edit": "Edit",
      "delete": "Delete"
    },
    "frequency": {
      "DAILY": "Daily",
      "WEEKLY": "Weekly",
      "MONTHLY": "Monthly",
      "YEARLY": "Yearly"
    },
    "status": {
      "sent": "Sent",
      "scheduled": "Scheduled",
      "cancelled": "Cancelled"
    },
    "send_by": {
      "push": "Push",
      "email": "Email",
      "both": "Both (Push and Email)"
    },
    "type": {
      "custom": "Custom",
      "custom_transport": "Transport",
      "system": "System"
    },
    "target": {
      "all": "All users",
      "all_clients": "All clients",
      "all_drivers": "All drivers",
      "specific_drivers": "Specific drivers",
      "specific_clients": "Specific clients",
      "custom": "Custom users"
    },
    "advice_custom_transport_no_edit": "Notifications linked to transports cannot be edited or resent from this module. They must be managed from Transport Assignment.",
    "filters": {
      "title": "Title",
      "send_to": "Send to",
      "scheduled": "Scheduled",
      "date_range": "Date range"
    },
    "editor": {
      "create_title": "Create notification",
      "edit_title": "Edit notification",
      "view_title": "Notification details",
      "title_label": "Title",
      "title_placeholder": "Type here...",
      "message_label": "Message",
      "message_placeholder": "Type the notification message...",
      "target_label": "Select notification recipient",
      "channel_label": "Delivery channel",
      "specific_drivers_title": "Specific drivers",
      "custom_recipients_title": "Custom recipients ({{count}})",
      "custom_transport_info_title": "Notification linked to a transport",
      "custom_transport_info_msg": "This notification was sent to custom recipients for transport {{id}}. It cannot be edited from this module; new communications must be managed from Transport Assignment.",
      "custom_transport_view_btn": "View transport {{id}}",
      "filter_name": "Name",
      "filter_email": "Email",
      "filter_city": "Province",
      "filter_phone": "Phone",
      "filter_tag": "Tags",
      "filter_status": "Status",
      "drivers_search_placeholder": "Search...",
      "selected_drivers_count": "{count} selected",
      "select_all": "Select all",
      "deselect_all": "Deselect all",
      "schedule_btn": "Schedule delivery",
      "edit_schedule_btn": "Modify schedule",
      "scheduled_badge": "Scheduled for:",
      "send_now": "Send",
      "save_changes": "Save changes",
      "cancel": "Cancel",
      "back": "Back",
      "validation_title": "Title is required.",
      "validation_message": "Message is required.",
      "validation_drivers": "You must select at least one driver.",
      "success_created": "Notification created and sent successfully.",
      "success_scheduled": "Notification scheduled successfully.",
      "success_updated": "Scheduled notification updated successfully.",
      "error_saving": "An error occurred while processing the notification."
    },
    "schedule_modal": {
      "title": "Schedule delivery",
      "mode_schedule": "Schedule delivery",
      "mode_now": "Send now",
      "date": "Date",
      "time": "Time",
      "timezone": "Timezone",
      "repeat": "Repeat delivery",
      "frequency": "Frequency",
      "every": "Every",
      "days": "day(s)",
      "weeks": "week(s)",
      "months": "month(s)",
      "years": "year(s)",
      "repeat_on": "Repeats on",
      "weekdays": {
        "MONDAY": "Mon",
        "TUESDAY": "Tue",
        "WEDNESDAY": "Wed",
        "THURSDAY": "Thu",
        "FRIDAY": "Fri",
        "SATURDAY": "Sat",
        "SUNDAY": "Sun"
      },
      "month_options": {
        "by_day": "Day of the month",
        "by_weekday": "Day of the week"
      },
      "month_day": "On day",
      "on_the": "On the",
      "nth_weekday": {
        "1": "First",
        "2": "Second",
        "3": "Third",
        "4": "Fourth"
      },
      "weekday_names": {
        "MONDAY": "Monday",
        "TUESDAY": "Tuesday",
        "WEDNESDAY": "Wednesday",
        "THURSDAY": "Thursday",
        "FRIDAY": "Friday",
        "SATURDAY": "Saturday",
        "SUNDAY": "Sunday"
      },
      "ends": "Ends",
      "never": "Never",
      "on_date": "On date",
      "after": "After",
      "occurrences": "deliveries",
      "save": "Save",
      "cancel": "Cancel"
    },
    "header": {
      "title": "Notifications",
      "empty": "You have no unread notifications",
      "mark_as_read": "Mark as read",
      "date_time": "Date and time"
    }
  },
  "regularizations": {
    "validation": {
      "required": "You must select an item",
      "field-required": "The field cannot be empty",
      "amount-positive": "Must have a valid positive numeric value",
      "message-min-length": "The comment must be at least 10 characters long"
    },
    "title": "Regularizations/Unassignments",
    "back": "Back",
    "driver-name": "Driver name",
    "transport": "Transport",
    "no-transport": "No transport",
    "regularization-type": "Regularization type",
    "type": "Type",
    "good-work": "Good work",
    "bad-work": "Bad work",
    "other": "Other",
    "comment": "Comment",
    "comment-placeholder": "Add a comment",
    "amount": "Amount",
    "save-changes": "Save changes",
    "select-regularization-type": "Select regularization type",
    "select-type": "Select type",
    "list": {
      "searchPlaceholder": "Search regularizations...",
      "driver_name": "Driver",
      "unassigned_by": "Unassigned by",
      "option": "Option",
      "percentage": "Percentage",
      "amount": "Import",
      "type": "Type",
      "status": "Status",
      "actions": "Actions",
      "create": "Add regularization",
      "transport-id": "Transport ID: ",
      "transport": "Transport",
      "types": {
        "regulation": "Regularization",
        "unassign": "Unassignment"
      },
      "statuses": {
        "pending": "Pending",
        "billed": "Billed"
      }
    },
    "edit": {
      "title": "Edit regularization"
    },
    "create": {
      "title": "Add regularization"
    },
    "unassign": {
      "title": "Manage unassignment",
      "servicePrice": "Service price",
      "payDriver": "Pay driver",
      "penalizeDriver": "Penalize driver",
      "onlyRemoveReservation": "Only remove reservation",
      "selectOptions": "Select options",
      "manualEntry": "Manual entry",
      "amountPlaceholder": "Amount",
      "removeDriver": "REMOVE DRIVER",
      "success": {
        "removed": "Driver unassigned successfully",
        "updated": "Unassignment modified successfully"
      },
      "errors": {
        "unassign_failed": "Error unassigning driver",
        "amount_required": "Amount required"
      }
    }
  },
  "additional-costs": {
    "searchPlaceholder": "Search...",
    "pending_admin": "Pending to manage",
    "pending_ticket": "Pending ticket",
    "columns": {
      "name": "Name",
      "dni_cif": "DNI / CIF",
      "email": "Email",
      "phone": "Phone",
      "rating": "Rating",
      "tags": "Tags",
      "transport": "Transport",
      "type": "Type",
      "amount_requested": "Req. Amount",
      "amount_quoted": "Quoted Amount",
      "status": "Status",
      "actions": "Actions"
    },
    "filters": {
      "tags": "Tags",
      "email": "Email",
      "name": "Name",
      "phone": "Phone",
      "rating": "Rating",
      "request_date": "Request Date Range",
      "modified_date": "Update Date Range",
      "status": "Status",
      "transport_id": "Transport ID"
    },
    "status": {
      "NEW": "New",
      "PENDING_TICKET": "Pending ticket",
      "EXPIRED": "Expired",
      "PENDING_VALIDATION": "Pending validation",
      "VALIDATED": "Validated",
      "REQUEST_REJECTED": "Request rejected",
      "TICKET_REJECTED": "Ticket rejected"
    },
    "request_type": {
      "TAXI": "Taxi",
      "BLABLACAR": "Blablacar",
      "TRAIN": "Train",
      "PLANE": "Plane",
      "TOLL": "Toll",
      "FUEL": "Fuel",
      "MEALS": "Meals (10% VAT)",
      "LODGING": "Lodging",
      "WAITING_TIME": "Waiting time",
      "ELECTRIC_VEHICLE_CHARGING_TIME": "Electric vehicle charging",
      "ADBLUE": "AdBlue",
      "OIL": "Oil",
      "FERRY": "Ferry",
      "OTHER": "Other"
    },
    "messages": {
      "export_error": "Error exporting additional costs"
    },
    "manage": {
      "title": "Manage request",
      "action_label": "Manage",
      "type": "Type",
      "price_without_tax": "Price (Taxes not included)",
      "price_with_vat": "Price ({{vat_percentage}}% VAT included)",
      "driver_comment": "Driver comment",
      "ticket": "Ticket",
      "vehicle_frame_photo": "Vehicle frame photo",
      "rejection_section_title": "Required for rejection",
      "rejection_reason": "Rejection reason",
      "select_reason": "Select a reason",
      "message": "Message",
      "message_placeholder": "Default message associated with the reason",
      "block_new_request": "Do not allow new request of this type from the driver on this transport",
      "exclude_from_invoice": "Do not charge the client on the invoice",
      "approve_request": "APPROVE REQUEST",
      "approve_expense": "APPROVE EXPENSE",
      "reject": "REJECT",
      "rejection_reason_required": "You must select a rejection reason",
      "load_error": "Error loading additional cost data",
      "reject_success": "Request rejected successfully",
      "reject_error": "Error rejecting the request",
      "approve_success": "Request approved successfully",
      "approve_error": "Error approving the request",
      "approve_ticket_success": "Expense approved successfully",
      "approve_ticket_error": "Error approving the expense"
    }
  },
  "driver-invoices": {
    "title": "Driver Invoices",
    "searchPlaceholder": "Search invoices...",
    "pending_payment": "Pending payment",
    "mark_as": "MARK AS",
    "export_csv": "EXPORT CSV",
    "export_csv_bank": "EXPORT CSV BANK",
    "download_selected_pdf": "DOWNLOAD SELECTED AS PDF",
    "columns": {
      "emission_date": "EMISSION",
      "payment_date": "PAYMENT",
      "name": "NAME",
      "dni_cif": "DNI / CIF",
      "email_phone": "EMAIL / PHONE",
      "embargo": "EMBARGO",
      "status": "STATUS",
      "total_amount": "TOTAL INVOICE (NO VAT)",
      "regs": "REGS.",
      "ttes": "TRANS.",
      "actions": "ACTION"
    },
    "filters": {
      "driver_email": "Driver email",
      "name": "Name",
      "dni_cif": "DNI / NIE / CIF",
      "phone": "Phone",
      "embargo": "Embargo",
      "status": "Invoice status",
      "total": "Total",
      "emission_date_range": "Emission date range",
      "payment_date_range": "Payment date range",
      "includes_regularizations": "Includes regularizations",
      "includes_transports": "Includes transports"
    },
    "embargo_options": {
      "yes": "Yes",
      "no": "No"
    },
    "status": {
      "PENDING_DRIVER": "Pending Driver",
      "PENDING_PAYMENT": "Pending Payment",
      "PAID": "Paid"
    },
    "actions": {
      "view": "View",
      "export_pdf": "Export PDF",
      "export_csv": "Export CSV",
      "export_bank": "Export Bank"
    },
    "mark_modal": {
      "title": "Mark invoices as",
      "pending_payment": "Pending payment",
      "paid": "Paid",
      "save": "SAVE"
    },
    "messages": {
      "no_selection": "No invoices selected",
      "no_selection_subtitle": "Select at least one invoice to change its status",
      "status_changed_success": "Status updated successfully",
      "status_changed_count": "{{count}} invoice(s) have been updated",
      "status_changed_error": "Error changing invoice status",
      "generating_pdf": "Generating PDF file, please wait...",
      "export_success": "File exported successfully",
      "export_error": "Error exporting invoices to PDF"
    }
  },
  "create-driver-invoices": {
    "title": "Driver Invoice Emission",
    "coming_soon": "Content coming soon",
    "drivers_list": "Drivers List",
    "invoices_to_emit": "Invoices to Emit",
    "emit_draft_selection": "EMIT DRAFT FROM SELECTION",
    "emit_individual_draft": "EMIT INDIVIDUAL DRAFT",
    "request_invoice_data": "Request invoice data",
    "loading": "Loading...",
    "no_invoice_data": "No invoice data available. Select drivers from the table above and click 'Request invoice data'.",
    "total_to_emit": "TOTAL TO EMIT",
    "select_all": "Select all",
    "transports": "Transports",
    "other_adjustments": "Other adjustments",
    "adjustments": "Adjustments",
    "draft": "Draft",
    "draft_placeholder": "Select transports or adjustments to add to draft",
    "searchPlaceholder": "Search drivers...",
    "columns": {
      "photo": "Photo",
      "name": "Name",
      "dni_nie": "DNI/NIE",
      "phone": "Phone",
      "email": "Email",
      "pending_transports": "Pending transports to invoice",
      "pending_adjustments": "Pending adjustments"
    },
    "tables": {
      "id": "ID",
      "status": "Status",
      "additional_costs": "Additional costs (excl. VAT)",
      "adjustments": "Adj. (Excl. VAT)",
      "total": "Total (Excl. VAT)",
      "type": "Type",
      "reason": "Reason",
      "sub_reason": "Sub-reason",
      "quantity": "Quantity",
      "amount": "Amount (excl. VAT)",
      "no_transports": "No transports available",
      "no_adjustments": "No adjustments available"
    },
    "tooltip": {
      "budget": "Budget",
      "total_price": "Total price",
      "additional_costs": "Additional costs",
      "adjustments": "Adjustments"
    },
    "summary": {
      "base_amount": "TAXABLE BASE",
      "vat": "VAT",
      "total": "TOTAL TO EMIT"
    },
    "filters": {
      "name": "Name",
      "dni_nie": "DNI/NIE",
      "email": "Email",
      "phone": "Phone",
      "transport_end_date": "Transport end date range"
    },
    "confirm_emit_individual": "Are you sure you want to emit the draft for this driver?",
    "confirm_emit_selection": "Are you sure you want to emit the drafts for all selected drivers?",
    "emit_success": "Invoices created successfully",
    "emit_error": "Error creating invoices",
    "no_items_selected": "No transports selected or not billable"
  },
  "client-invoices": {
    "title": "Client Invoice Management",
    "searchPlaceholder": "Search invoices...",
    "pending_payment": "Pending payment",
    "mark_as": "MARK AS",
    "manual_emission": "MANUAL INVOICE EMISSION",
    "export_csv": "EXPORT CSV",
    "export_csv_bank": "EXPORT CSV BANK",
    "download_selected_pdf": "DOWNLOAD SELECTED AS PDF",
    "columns": {
      "invoice_number": "INVOICE NO.",
      "group": "GROUP",
      "entity_sub": "ENTITY/SUB",
      "cif": "CIF",
      "emission_date": "EMISSION",
      "expiration_date": "EXPIRATION",
      "total_transports": "TOTAL TRANS.",
      "amount_no_vat": "AMOUNT (NO VAT)",
      "status": "STATUS",
      "actions": "ACTION"
    },
    "filters": {
      "invoice_number": "Invoice No.",
      "group": "Group",
      "entity": "Entity",
      "subentity": "Subentity",
      "cif": "CIF",
      "status": "Status",
      "emission_date_range": "Invoice emission",
      "expiration_date_range": "Invoice expiration",
      "pending_overdue": "Pending invoices with past due date"
    },
    "status": {
      "PENDING_DRIVER": "Pending Driver",
      "PENDING_PAYMENT": "Pending Payment",
      "PAID": "Paid"
    },
    "actions": {
      "view": "View invoice",
      "download_pdf": "Download PDF",
      "download_csv": "Download CSV",
      "download_bank": "Download bank format"
    },
    "mark_modal": {
      "title": "Mark invoices as",
      "pending_payment": "Pending payment",
      "paid": "Paid",
      "save": "SAVE"
    },
    "messages": {
      "no_selection": "No invoices selected",
      "no_selection_subtitle": "Select at least one invoice to change its status",
      "status_changed_success": "Status updated successfully",
      "status_changed_count": "{{count}} invoice(s) have been updated",
      "status_changed_error": "Error changing invoice status",
      "generating_pdf": "Generating PDF file, please wait...",
      "export_success": "File exported successfully",
      "export_error": "Error exporting invoices to PDF"
    }
  },
  "invoice-detail": {
    "title": "Invoice Detail",
    "invoice_number_label": "Invoice No",
    "detail_title": "Invoice detail",
    "data_title": "Invoice Data",
    "transports_title": "Transports",
    "no_transports": "No transports associated with this invoice",
    "status": {
      "PENDING_DRIVER": "Pending Driver",
      "PENDING_PAYMENT": "Pending Payment",
      "PAID": "Paid"
    },
    "fields": {
      "invoice_number": "Invoice No",
      "status": "Status",
      "name": "Name",
      "dni_nie_cif": "DNI / NIE / CIF",
      "irpf": "IRPF",
      "phone": "Phone",
      "address": "Address",
      "address_complement": "Address complement",
      "country": "Country",
      "province": "Province",
      "city": "City",
      "postal_code": "Postal Code",
      "iban": "IBAN",
      "bic_swift": "BIC / SWIFT",
      "group": "Group",
      "entity": "Entity",
      "subentity": "Subentity",
      "billing_center": "Billing center",
      "cif": "CIF",
      "emission_date": "Invoice emission date",
      "expiration_date": "Invoice expiration date",
      "payment_date": "Invoice payment date",
      "transports_count": "Transport count",
      "finished_transports_count": "Finished transports count",
      "cancelled_transports_count": "Cancelled transports count",
      "annulled_transports_count": "Annulled transports count",
      "base_amount": "Taxable base",
      "irpf_amount": "IRPF",
      "vat_amount": "VAT",
      "total_amount": "Total to issue"
    },
    "transport_columns": {
      "transport_number": "TRANSPORT NO",
      "license_plate": "LICENSE PLATE",
      "status": "STATUS",
      "pickup": "PICKUP",
      "stopover": "STOPOVER",
      "delivery": "DELIVERY",
      "price": "TOTAL (NO VAT)",
      "additional_costs": "ADD. COSTS (NO VAT)",
      "regs_amount": "REGS. (NO VAT)",
      "regs": "REGS.",
      "penalty": "PENALTY"
    },
    "transport_status": {
      "FINISHED": "Finished",
      "CANCELLED": "Cancelled",
      "EXPIRED": "Expired",
      "IN_PROGRESS": "In progress",
      "PENDING": "Pending",
      "UNASSIGNED": "Annulled"
    },
    "actions": {
      "save": "SAVE"
    },
    "messages": {
      "load_error": "Error loading invoice detail",
      "status_changed_success": "Status updated successfully",
      "status_changed_error": "Error changing status",
      "invoice_number_error": "Error updating invoice number",
      "save_success": "Changes saved successfully",
      "invoice_number_required": "Invoice number is required",
      "generating_pdf": "Generating PDF file, please wait...",
      "export_success": "File exported successfully",
      "export_error": "Error exporting invoices to PDF"
    }
  },
  "client-invoice-transport-detail": {
    "title": "Transport Detail",
    "price": {
      "title": "Price",
      "transport": "Transport price (NO VAT)",
      "fuel": "Fuel (NO VAT)",
      "ferry": "Ferry (NO VAT)",
      "electric_charge": "Electric charge (NO VAT)"
    },
    "additional_costs": {
      "title": "Additional costs",
      "type": "Additional cost type",
      "amount": "Price no VAT",
      "no_data": "No additional costs"
    },
    "cancellation": {
      "title": "Cancellation",
      "penalty": "Cancellation penalty",
      "cancelled_by": "Who cancelled",
      "reason": "Cancellation reason"
    },
    "dates": {
      "title": "Dates",
      "pickup": "Driver pickup",
      "delivery": "Driver delivery"
    },
    "summary": {
      "base_amount": "Taxable base",
      "vat": "VAT",
      "total": "Total to issue"
    }
  },
  "addresses": {
    "title": "Addresses",
    "back": "Back",
    "list": {
      "searchPlaceholder": "Search addresses...",
      "address": "Address",
      "type": "Type",
      "schedule": "Schedule",
      "entity": "Entity/Subentity",
      "name": "Name",
      "email": "Email",
      "phone": "Phone",
      "actions": "Actions",
      "address-type": "Address type",
      "entity-filter": "Entity",
      "contact-name": "Contact name",
      "contact-email": "Contact email",
      "contact-phone": "Contact phone",
      "subentity": "Subentity",
      "create": "Create new address"
    },
    "edit": {
      "title": "Edit address"
    },
    "create": {
      "title": "New address"
    },
    "editor": {
      "days": {
        "mon": "mon",
        "tue": "tue",
        "wed": "wed",
        "thu": "thu",
        "fri": "fri",
        "sat": "sat",
        "sun": "sun"
      },
      "time-range": "Time range",
      "add": "ADD",
      "add-time-slot-card": "ADD TIME SLOT",
      "contacts-title": "Contacts",
      "main-contact": "Main contact",
      "notify-email": "Notify the contact email when a transport is going to be picked up or delivered to the address.",
      "overwrite-contact": "Overwrite contact",
      "main": "Main",
      "actions": "Actions",
      "yes": "Yes",
      "no": "No",
      "save": "SAVE",
      "pickup-title": "Pickup address",
      "name": "Name",
      "address-type": "Address type",
      "country": "Country",
      "province": "Province",
      "city": "City",
      "postal-code": "Postal code",
      "address": "Address",
      "address-complement": "Address complement",
      "entity": "Entity",
      "subentity": "Subentity",
      "contact-name": "Contact name",
      "contact-email": "Contact email",
      "contact-phone": "Contact phone",
      "schedule-title": "Schedule",
      "pickup-contact-title": "Pickup Contact",
      "delivery-contact-title": "Delivery Contact",
      "intermediate-contact-title": "Intermediate Stage Contact",
      "final-delivery-contact-title": "Final Delivery Contact",
      "errors": {
        "name-required": "Name is required",
        "phone-required": "Phone is required",
        "email-notification-required": "Email is required"
      }
    },
    "errors": {
      "title_required": "Address name is required",
      "street_address_required": "Street address is required",
      "city_required": "City is required",
      "province_required": "Province is required",
      "postal_code_required": "Postal code is required",
      "country_required": "Country is required",
      "address_type_required": "Address type is required",
      "entity_required": "Entity is required",
      "opening_hours_required": "You must define at least one time slot for the selected days",
      "one_contact_required": "At least one contact is required",
      "main_contact_required": "You must select a main contact",
      "fix_errors": "Please fix the errors before saving",
      "delete_error_title": "Error",
      "delete_error_message": "The address could not be deleted"
    },
    "delete_confirm_title": "Delete address",
    "delete_confirm_message": "Are you sure you want to delete the current address?"
  },
  "users-entities": {
    "title": "Entity users",
    "list": {
      "name": "Name",
      "lastname": "Last Name",
      "email": "Email",
      "entity": "Entity",
      "subentity": "Subentity",
      "phone": "Phone",
      "actions": "Actions",
      "searchPlaceholder": "Search..."
    },
    "filters": {
      "name": "Name",
      "lastname": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "entity": "Entity",
      "subentity": "Subentity"
    },
    "actions": {
      "create": "Create new entity user",
      "edit": "Edit",
      "delete": "Delete"
    },
    "messages": {
      "delete_confirm": "Are you sure you want to delete this entity user?",
      "delete_success": "Entity user deleted successfully",
      "delete_error": "Error deleting entity user"
    },
    "editor": {
      "error-password-required": "Password is required",
      "title": "Edit client/entity",
      "title-new": "Create new client/entity",
      "is-superadmin": "Admin",
      "name": "Name",
      "lastname": "Last Name",
      "email": "Email",
      "phone": "Phone",
      "password": "Password",
      "generate-password": "Create secure password",
      "client-group": "Client group",
      "select-entities-subentities": "Select entities and subentities",
      "add-main-client": "Add main client",
      "subentity": "Subentity",
      "entities": "Entity",
      "subentities": "Subentities",
      "add": "Add",
      "entities-subentities": "Entities/Subentities",
      "assign-main-entity": "ASSIGN TO MAIN ENTITY",
      "assign-subentity": "ASSIGN TO SUBENTITY",
      "billing-accounts": "Billing accounts",
      "notifications": "My notifications",
      "new-transport-notification": "Email notification transport created",
      "driver-assigned-notification": "Email notification driver assigned",
      "transport-finished-notification": "Email notification transport finished",
      "cancelled-transport-notification": "Email notification transport cancelled",
      "other-emails": "Other emails",
      "other-emails-description": "Write here the email address to send the selected notifications.",
      "other-emails-placeholder": "Type an email and press Enter",
      "other-emails-hint": "Each added email will be displayed as a tag.",
      "save-changes": "Save changes",
      "cancel": "Cancel",
      "no-entities-selected": "You must select at least one entity or subentity.",
      "no-subentities": "No subentities associated with this entity have been selected.",
      "no-entities": "No entity associated with the selected subentities has been selected.",
      "error-at-least-one-entity": "You must add at least one entity or subentity before saving.",
      "error-invalid-email": "The email is not valid."
    }
  },
  "statics-page": {
    "construction-title": "Page under construction",
    "construction-subtitle": "We are working to bring you this new feature soon.",
    "noauth-title": "You are not authorized to access this route",
    "notexist-title": "Page does not exist",
    "notexist-description": "The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.",
    "back-to-dashboard": "Back to dashboard",
    "duplicate-tab-title": "Duplicate tab",
    "duplicate-tab-description": "You already have a session open in another tab. Close that tab to continue."
  },
  "transportPrincipalType": {
    "SIMPLE_MOVEMENT": "Simple movement",
    "PICKUP_TO_FINAL_CUSTOMER": "Pickup to final customer",
    "DELIVERY_TO_FINAL_CUSTOMER": "Delivery to final customer",
    "PICKUP_AND_DELIVERY_TO_FINAL_CUSTOMER": "Pickup and delivery to final customer",
    "WITH_STOPOVER": "With stopover"
  },
  "transportStatus": {
    "PENDING": "Pending",
    "PLANIFIED": "Planned",
    "IN_COURSE": "In course",
    "FINISHED": "Finished",
    "CANCELLED": "Cancelled",
    "DELETED": "Deleted",
    "EXPIRED": "Expired",
    "DELIVERED": "Delivered",
    "COLLECTED": "Collected",
    "IN_STOPOVER": "In stopover",
    "UNASSIGNED": "Annulled"
  },
  "cancelledReason": {
    "VEHICLE_NOT_AVAILABLE": "Vehicle not available",
    "VEHICLE_NOT_READY_AT_DEPARTURE": "Vehicle not ready at departure",
    "VEHICLE_NOT_WORKING": "Vehicle not working",
    "MISSING_MANDATORY_SAFETY_EQUIPMENT": "Missing mandatory safety equipment",
    "INCORRECT_LICENSE_PLATE": "Incorrect license plate",
    "BREAKDOWN_DURING_TRANSPORT": "Breakdown during transport",
    "ACCIDENT_DURING_TRANSPORT": "Accident during transport",
    "VEHICLE_REJECTED_AT_ARRIVAL": "Vehicle rejected at arrival",
    "VEHICLE_REJECTED_NO_APPOINTMENT_AT_DEPOT": "Vehicle rejected, no appointment at depot",
    "RETURN_REJECTED": "Return rejected",
    "END_CUSTOMER_REQUEST": "End customer request",
    "CUSTOMER_REQUEST": "Customer request",
    "CANCELLATION_DUE_TO_DRIVER_RESERVATION_CANCELLED": "Cancellation due to driver reservation cancelled",
    "RETURN_CANCELLED_DUE_TO_OUTBOUND_CANCELLATION": "Return cancelled due to outbound cancellation",
    "CONTACT_ABSENT_AT_DEPARTURE": "Contact absent at departure",
    "CONTACT_ABSENT_AT_ARRIVAL": "Contact absent at arrival",
    "UNREACHABLE_CONTACT_AT_START": "Unreachable contact at start",
    "UNREACHABLE_CONTACT_AT_ARRIVAL": "Unreachable contact at arrival",
    "NO_APPOINTMENT_POSSIBLE_WITH_END_CUSTOMER": "No appointment possible with end customer",
    "NO_APPOINTMENT_WITH_ARRIVAL_CONTACT": "No appointment with arrival contact",
    "DUPLICATE": "Duplicate",
    "INCORRECT_PICKUP_ADDRESS": "Incorrect pickup address",
    "INCORRECT_DELIVERY_ADDRESS": "Incorrect delivery address",
    "NON_COMPLIANT_TRANSPORT_REQUEST": "Non-compliant transport request",
    "CANCELLATION_DUE_TO_CAPACITY": "Cancellation due to capacity",
    "OTHER": "Other"
  },
  "legPointType": {
    "ORIGIN": "Origin",
    "STOPOVER": "Stopover",
    "STAGE": "Stage",
    "DESTINATION": "Destination"
  },
  "connectionType": {
    "STOPOVER": "Stopover",
    "STAGE": "Stage"
  },
  "clientType": {
    "DEALERSHIP": "Dealership",
    "RENTING": "Renting",
    "LEASING": "Leasing",
    "CAR_RENTAL": "Car rental",
    "CAR_TRADING": "Car trading",
    "FLEET": "Fleet",
    "COMPANY": "Company"
  },
  "billingType": {
    "MANUAL": "Manual",
    "AUTOMATIC": "Automatic",
    "BY_FINISHED_TRANSPORT": "By finished transport"
  },
  "clientOrigin": {
    "PROSPECTING": "Prospecting",
    "REFERRAL": "Referral",
    "MARKETING": "Marketing",
    "INBOUND_REQUEST": "Inbound request",
    "OTHERS": "Others",
    "UNDEFINED": "Undefined",
    "EVENT": "Event"
  },
  "requestType": {
    "TRANSPORT": "Transport",
    "TOLL": "Toll",
    "FUEL": "Fuel",
    "MEALS": "Meals",
    "LODGING": "Lodging",
    "WAITING_TIME": "Waiting time",
    "ELECTRIC_VEHICLE_CHARGING_TIME": "EV charging",
    "OTHER": "Other"
  },
  "requestStatus": {
    "NEW": "New",
    "PENDING_TICKET_UPLOAD": "Pending ticket",
    "PENDING_VALIDATION": "Pending validation",
    "VALIDATED": "Validated",
    "REQUEST_REJECTED": "Request rejected",
    "TICKET_REJECTED": "Ticket rejected"
  },
  "pricingType": {
    "FIXED": "Fixed",
    "PER_KM": "Per km"
  },
  "adjustmentType": {
    "BONUS": "Bonus",
    "PENALTY": "Penalty"
  },
  "adjustmentOrigin": {
    "INCIDENCE": "Incidence",
    "OTHER": "Other",
    "TRANSPORT": "Transport",
    "UNASSIGNATION": "Unassignation"
  },
  "adjustmentReason": {
    "DOCUMENTATION_INVENTORY": "Documentation / Inventory",
    "PUNCTUALITY": "Punctuality",
    "WRONG_DELIVERY": "Wrong delivery / abandonment",
    "FUEL": "Fuel",
    "ADDITIONAL_SERVICES": "Additional services",
    "EXCESS_KILOMETERS": "Excess kilometers",
    "BEHAVIOR_APPEARANCE": "Behavior / Appearance",
    "DAMAGES": "Accident / Damage",
    "FINE": "Fine",
    "BILLING": "Billing / expenses",
    "OPERATIONS_PROCESS": "Operations process",
    "FRAUD": "Fraud",
    "DRIVER_RECOGNITION": "Congratulation",
    "UNASSIGNATION": "Unassignation",
    "OTHER": "Other"
  },
  "adjustmentSubType": {
    "ADDITIONAL_SERVICES_OTHER": "Other",
    "BAD_DRESSING": "Inappropriate dressing",
    "BAD_TREATMENT": "Incorrect treatment",
    "BEHAVIOR_OTHER": "Other",
    "BILL_FAKE_RECEIPT": "Fake receipts",
    "BILL_OTHER": "Other expense or irregularity",
    "BRIEFING_NOT_DONE": "Explained delivery not performed",
    "BROKEN_GLASS": "Glass breakage",
    "CLEANING_INCOMPLETE": "Incomplete cleaning",
    "DAMAGE_EXTERNAL": "External damage",
    "DAMAGE_INTERNAL": "Internal damage",
    "DAMAGE_OTHER": "Other",
    "DELIVERY_INSTRUCTIONS_IGNORED": "Delivery instructions not followed",
    "DOC_INCOMPLETE": "Incomplete documentation",
    "DOC_INVALID": "Invalid document",
    "DOC_NOT_SENT": "Documentation not sent",
    "DOC_OTHER": "Other documentation issue",
    "DRIVER_RECOGNITION": "Congratulation",
    "EXTRA_DISTANCE": "Extra distance (km)",
    "FINE_OTHER": "Other sanction",
    "FINE_PARKING": "Parking",
    "FINE_SPEED": "Speeding",
    "FINE_TOLL": "Toll or restricted access",
    "FRAUD_FAKE_BREAKDOWN": "Fake/non-existent breakdown",
    "FRAUD_FAKE_DOCUMENT": "Falsified documentation",
    "FRAUD_FAKE_JUSTIFICATION": "Fake justification",
    "FUEL_INCOHERENT": "Incoherent consumption for the journey",
    "FUEL_LOW_LEVEL": "Lower level than expected",
    "FUEL_NO_DASH_PHOTO": "Dashboard photo not provided",
    "FUEL_OTHER": "Other",
    "INAPPROPRIATE_COMMENTS": "Inappropriate comments",
    "INVENTORY_INCOMPLETE": "Incomplete photos or inventory",
    "KM_EXCEEDED": "Exceeded kilometers compared to expected",
    "MISUSE": "Misuse of vehicle",
    "OP_MISSION_NOT_CLOSED": "Mission not closed",
    "OP_NO_COMMUNICATION": "No communication of incident",
    "OP_NO_RESPONSE": "No response in accident/breakdown/emergency",
    "OP_OTHER": "Other",
    "OP_UNREPORTED_CHANGES": "Unreported modification",
    "OTHER_GENERAL": "Other",
    "PUBLIC_ROAD": "Vehicle on public road",
    "PUNCTUALITY_DELAY": "Delay/advance (with hours)",
    "SERVICE_NOT_PERFORMED": "Service not performed as requested",
    "SIGNATURE_MISSING": "Missing signature/validation",
    "TIRE_PUNCTURE": "Puncture / tire",
    "UNAUTHORIZED_AREA": "Parked in unauthorized area",
    "UNPROFESSIONAL": "Unprofessionalism",
    "WASH_NOT_DONE": "Wash not done",
    "WRONG_DELIVERY_OTHER": "Other",
    "WRONG_FUEL": "Wrong fuel",
    "WRONG_LOCATION": "Vehicle outside agreed point",
    "WRONG_PERSON": "Not delivered to the corresponding person"
  },
  "validation": {
    "image": {
      "invalid_jpg_png_gif": "Invalid file type. Only images are allowed (JPG, PNG, GIF)."
    }
  },
  "certification": {
    "title_placeholder": "Certification title",
    "empty_category": "No certifications available in this category",
    "select_clients_prompt": "To view certifications, select one or more clients from the list above"
  },
  "documents": {
    "empty_category": "No documents available in this category",
    "no_related": "Sin documentos relacionados"
  },
  "regulation": {
    "type": {
      "unassign": "Unassign",
      "regulation": "Regulation"
    },
    "status": {
      "billed": "Billed"
    }
  },
  "footer": {
    "cookies": "Cookies",
    "privacy": "Privacy",
    "terms_conditions": "Terms and conditions"
  },
  "reasonType": {
    "MISSING_DOCUMENT": "Missing document",
    "FINE_MANAGEMENT": "Fine management",
    "ACCIDENT_MANAGEMENT": "Accident management",
    "ADDITIONAL_SERVICE": "Additional service",
    "INAPPROPRIATE_BEHAVIOR": "Inappropriate behavior",
    "UNPROFESSIONAL_DRESS": "Unprofessional dress",
    "NOT_RESPECT_PROCESS": "Does not respect process",
    "PUNCTUALITY_LESS_4H": "Punctuality <4h",
    "PUNCTUALITY_MORE_4H": "Punctuality >4h",
    "PUNCTUALITY_MORE_1D": "Punctuality >1d",
    "FALSE_JUSTIFICATIONS": "False justifications",
    "SERVICE_NOT_COMPLETED": "Service not completed",
    "SERVICE_NOT_CERTIFIED": "Service not certified",
    "OTHER": "Other"
  },
  "invoiceStatus": {
    "PENDING_DRIVER": "Pending driver",
    "PENDING_PAYMENT": "Pending payment",
    "PAID": "Paid"
  },
  "anomalyType": {
    "SCRATCH": "Scratch",
    "DENT": "Dent",
    "BREAK": "Breakage",
    "CHIP": "Chip / Impact",
    "MISSING_ITEM": "Missing Item",
    "POOR_CONDITION": "Poor Condition",
    "DIRTY": "Dirty",
    "DESCRIPTION": "Description",
    "OTHER": "Other"
  },
  "anomalyCategory": {
    "BODYWORK": "Bodywork",
    "GLASS": "Glass",
    "INTERIOR": "Interior",
    "OTHER": "Other"
  },
  "incidenceType": {
    "ALL": "All",
    "PUNCTUALITY": "Punctuality",
    "EXCESS_KILOMETERS": "Excess km",
    "INVENTORY_MISSING": "Missing inventory",
    "INVENTORY_INCOMPLETE": "Incomplete inventory",
    "DRIVER_BEHAVIOR": "Driver behavior",
    "DRIVER_APPEARANCE": "Driver appearance",
    "DRIVER_CONGRATULATIONS": "Driver congratulations",
    "OTHER": "Other",
    "DOCUMENT_MISSING": "Missing document",
    "DOCUMENT_BLURRED": "Blurred document",
    "DOCUMENT_INCOMPLETE": "Incomplete document",
    "DOCUMENT_INCORRECT": "Incorrect document",
    "CLIENT_PROTOCOL_FUEL": "Client protocol: fuel",
    "CLIENT_PROTOCOL_CUSTOMER_CONTACT": "Client protocol: contact",
    "CLIENT_PROTOCOL_SC_ADDITIONAL_SERVICE": "Client protocol: add. service",
    "CLIENT_PROTOCOL_SC_WASH": "Client protocol: wash",
    "CLIENT_PROTOCOL_SC_VEHICLE_PRESENTATION": "Client protocol: presentation",
    "CLIENT_PROTOCOL_OTHER": "Client protocol: other",
    "INCIDENCE_OTHER_OR_MULTIPLE": "Other or multiple",
    "INCIDENCE_THEFT_SUSPICION": "Theft suspicion",
    "INCIDENCE_BODYWORK_DAMAGE": "Bodywork damage",
    "INCIDENCE_GLASS_BREAKAGE": "Glass breakage",
    "INCIDENCE_FLAT_TIRE": "Flat tire",
    "INCIDENCE_WRONG_FUEL": "Wrong fuel",
    "INCIDENCE_INTERIOR_DAMAGE": "Interior damage",
    "FINE_OVERSPEED": "Fine: overspeed",
    "FINE_TOLL": "Fine: toll",
    "FINE_UNPAID_PARKING": "Fine: unpaid parking",
    "FINE_OTHER": "Fine: other",
    "FINE_TRAFFIC_CODE": "Fine: traffic code",
    "BILLING_FAKE_RECEIPTS": "Fake receipts",
    "INTERNAL_PROTOCOL_EMERGENCY_CONTACT": "Internal protocol: emergency",
    "INTERNAL_PROTOCOL_WARNING_NOTE": "Internal protocol: warning",
    "INTERNAL_PROTOCOL_30_MIN_WAIT": "Internal protocol: 30min wait",
    "INTERNAL_PROTOCOL_UNREPORTED_CHANGES": "Internal protocol: unreported changes",
    "INTERNAL_PROTOCOL_MISSION_NOT_COMPLETED": "Internal protocol: mission not completed",
    "INTERNAL_PROTOCOL_OTHER": "Internal protocol: other"
  },
  "incidenceMainType": {
    "DOCUMENTATION_INVENTORY": "Documentation / Inventory",
    "PUNCTUALITY": "Punctuality",
    "WRONG_DELIVERY": "Wrong delivery / abandonment",
    "FUEL": "Fuel",
    "ADDITIONAL_SERVICES": "Additional services",
    "EXCESS_KILOMETERS": "Excess kilometers",
    "BEHAVIOR_APPEARANCE": "Behavior / Appearance",
    "DAMAGES": "Accident / Damage",
    "FINE": "Fine",
    "BILLING": "Billing / expenses",
    "OPERATIONS_PROCESS": "Operations process",
    "FRAUD": "Fraud",
    "DRIVER_RECOGNITION": "Congratulation",
    "OTHER": "Other"
  },
  "incidenceSubType": {
    "ADDITIONAL_SERVICES_OTHER": "Other",
    "BAD_DRESSING": "Inappropriate dressing",
    "BAD_TREATMENT": "Incorrect treatment",
    "BEHAVIOR_OTHER": "Other",
    "BILL_FAKE_RECEIPT": "Fake receipts",
    "BILL_OTHER": "Other expense or irregularity",
    "BRIEFING_NOT_DONE": "Explained delivery not performed",
    "BROKEN_GLASS": "Glass breakage",
    "CLEANING_INCOMPLETE": "Incomplete cleaning",
    "DAMAGE_EXTERNAL": "External damage",
    "DAMAGE_INTERNAL": "Internal damage",
    "DAMAGE_OTHER": "Other",
    "DELIVERY_INSTRUCTIONS_IGNORED": "Delivery instructions not followed",
    "DOC_INCOMPLETE": "Incomplete documentation",
    "DOC_INVALID": "Invalid document",
    "DOC_NOT_SENT": "Documentation not sent",
    "DOC_OTHER": "Other documentation issue",
    "DRIVER_RECOGNITION": "Congratulation",
    "EXTRA_DISTANCE": "Extra distance (km)",
    "FINE_OTHER": "Other sanction",
    "FINE_PARKING": "Parking",
    "FINE_SPEED": "Speeding",
    "FINE_TOLL": "Toll or restricted access",
    "FRAUD_FAKE_BREAKDOWN": "Fake/non-existent breakdown",
    "FRAUD_FAKE_DOCUMENT": "Falsified documentation",
    "FRAUD_FAKE_JUSTIFICATION": "Fake justification",
    "FUEL_INCOHERENT": "Incoherent consumption for the journey",
    "FUEL_LOW_LEVEL": "Lower level than expected",
    "FUEL_NO_DASH_PHOTO": "Dashboard photo not provided",
    "FUEL_OTHER": "Other",
    "INAPPROPRIATE_COMMENTS": "Inappropriate comments",
    "INVENTORY_INCOMPLETE": "Incomplete photos or inventory",
    "KM_EXCEEDED": "Exceeded kilometers compared to expected",
    "MISUSE": "Misuse of vehicle",
    "OP_MISSION_NOT_CLOSED": "Mission not closed",
    "OP_NO_COMMUNICATION": "No communication of incident",
    "OP_NO_RESPONSE": "No response in accident/breakdown/emergency",
    "OP_OTHER": "Other",
    "OP_UNREPORTED_CHANGES": "Unreported modification",
    "OTHER_GENERAL": "Other",
    "PUBLIC_ROAD": "Vehicle on public road",
    "PUNCTUALITY_DELAY": "Delay/advance (with hours)",
    "SERVICE_NOT_PERFORMED": "Service not performed as requested",
    "SIGNATURE_MISSING": "Missing signature/validation",
    "TIRE_PUNCTURE": "Puncture / tire",
    "UNAUTHORIZED_AREA": "Parked in unauthorized area",
    "UNPROFESSIONAL": "Unprofessionalism",
    "WASH_NOT_DONE": "Wash not done",
    "WRONG_DELIVERY_OTHER": "Other",
    "WRONG_FUEL": "Wrong fuel",
    "WRONG_LOCATION": "Vehicle outside agreed point",
    "WRONG_PERSON": "Not delivered to the corresponding person"
  },
  "incidenceCreator": {
    "ADMIN": "Admin",
    "CLIENT": "Client"
  },
  "incidenceStatus": {
    "NEW": "New",
    "PENDING_DRIVER": "Pending driver",
    "PENDING_CLIENT": "Pending client",
    "PENDING_END_CUSTOMER": "Pending end customer",
    "PENDING_INTERNAL_COLLABORATOR": "Pending internal collaborator",
    "PENDING_WORKSHOP": "Pending workshop",
    "PENDING_INSURANCE": "Pending insurance",
    "FINISHED": "Finished"
  },
  "severity": {
    "NONE": "None",
    "LOW": "Low",
    "MEDIUM": "Medium",
    "HIGH": "High"
  },
  "responsibility": {
    "DRIVER": "Driver",
    "FORCE_MAJEURE": "Force majeure",
    "CLIENT": "Client",
    "END_CLIENT": "End client",
    "INTERNAL_PROCESS": "Internal process",
    "DUPLICATE": "Duplicate",
    "TECHNICAL_ISSUE": "Technical issue",
    "NOT_APPLICABLE": "Not applicable",
    "THIRD_PARTY": "Third party"
  },
  "protocolType": {
    "SINGLE_CHECK": "Single check",
    "MULTI_CHECK": "Multi check",
    "IMAGE": "Image"
  },
  "directionType": {
    "ARRIVAL": "Arrival",
    "DEPARTURE": "Departure",
    "BOTH": "Both"
  },
  "transportEventType": {
    "CREATED": "Created",
    "UPDATED": "Updated",
    "DRIVER_ASSIGNED": "Driver assigned",
    "DRIVER_CHANGED": "Driver changed",
    "CLIENT_CANCELED": "Canceled by client",
    "DRIVER_CANCELED": "Canceled by driver",
    "CLIENT_APPT_SELECTED": "Client appt. selected",
    "DRIVER_DATETIME_SET": "Driver datetime set",
    "PICKUP_DONE": "Pickup done",
    "DOC_START_UPLOADED": "Doc. start uploaded",
    "DOC_END_UPLOADED": "Doc. end uploaded",
    "EXPENSE_TICKET_UPL": "Expense ticket uploaded",
    "DELIVERY_DONE": "Delivery done",
    "MISSION_FINISHED": "Mission finished"
  },
  "driverEventType": {
    "ONBOARD_REGISTERED": "Onboard registered",
    "DOC_UPLOADED": "Doc. uploaded",
    "DOC_VALIDATED": "Doc. validated",
    "DOC_REJECTED": "Doc. rejected",
    "PROFILE_UPDATED": "Profile updated",
    "QUOTE_SENT": "Quote sent",
    "QUOTE_REJECTED": "Quote rejected",
    "TRANSPORT_ASSIGNED": "Transport assigned",
    "EXTRA_EXPENSE_REQUESTED": "Extra expense requested",
    "EXTRA_EXPENSE_ACCEPTED": "Extra expense accepted",
    "EXTRA_EXPENSE_REJECTED": "Extra expense rejected",
    "TICKET_UPLOADED": "Ticket uploaded",
    "TICKET_ACCEPTED": "Ticket accepted",
    "TICKET_REJECTED": "Ticket rejected",
    "QUALITY_ISSUE_REPORTED": "Quality issue reported"
  },
  "incidenceEventType": {
    "OPENED": "Opened",
    "COMMENT_ADDED": "Comment added",
    "STATUS_CHANGED": "Status changed",
    "UPDATED": "Incident updated"
  },
  "documentType": {
    "front_dni": "Front DNI",
    "back_dni": "Back DNI",
    "front_driving_license": "Front driving license",
    "back_driving_license": "Back driving license",
    "self_employment_registration_fee": "Self-employment reg. fee",
    "bank_account_certificate": "Bank account cert.",
    "criminal_record_certificate": "Criminal record cert.",
    "driving_points_certificate": "Driving points cert.",
    "self_employment_payment_certificate": "Self-employment payment cert.",
    "tax_census_registration_certificate": "Tax census reg. cert.",
    "form_036": "Form 036",
    "reta_registration_resolution": "RETA reg. resolution",
    "social_security_compliance_certificate": "Social security cert.",
    "tax_debt_certificate": "Tax debt cert.",
    "residence_permit_nie": "Residence permit NIE",
    "work_permit_nie": "Work permit NIE"
  },
  "incidenceSeverity": {
    "LOW": "Low",
    "MEDIUM": "Medium",
    "HIGH": "High",
    "CRITICAL": "Critical"
  },
  "certificationStatus": {
    "passed": "Passed",
    "revoked": "Revoked",
    "manual": "Manual"
  },
  "examQuestionType": {
    "single": "Single answer",
    "multiple": "Multiple answer",
    "text": "Text",
    "boolean": "Yes/No"
  },
  "status": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "PENDING": "Pending",
    "COMPLETED": "Completed",
    "CANCELLED": "Cancelled"
  },
  "priority": {
    "LOW": "Low",
    "MEDIUM": "Medium",
    "HIGH": "High",
    "URGENT": "Urgent"
  },
  "notificationType": {
    "SUCCESS": "Success",
    "ERROR": "Error",
    "WARNING": "Warning",
    "INFO": "Info"
  },
  "tagType": {
    "CLIENT": "Client",
    "DRIVER": "Driver",
    "TRANSPORT": "Transport",
    "INCIDENCE": "Incidence"
  },
  "sortOrder": {
    "ASC": "Ascending",
    "DESC": "Descending"
  },
  "actionType": {
    "CREATE": "Create",
    "READ": "Read",
    "UPDATE": "Update",
    "DELETE": "Delete"
  },
  "vehicleSize": {
    "SMALL": "Small",
    "MEDIUM": "Medium",
    "LARGE": "Large"
  },
  "fuelType": {
    "GASOLINE": "Gasoline",
    "DIESEL": "Diesel",
    "ELECTRIC": "Electric",
    "HYBRID": "Hybrid",
    "PLUG_IN_HYBRID": "Plug-in hybrid",
    "LPG": "LPG",
    "CNG": "CNG",
    "COMBUSTION": "Combustion"
  },
  "bodyType": {
    "SEDAN": "Sedan",
    "COUPE": "Coupe",
    "HATCHBACK": "Hatchback",
    "SUV": "SUV",
    "WAGON": "Wagon",
    "VAN": "Van",
    "PICKUP": "Pickup",
    "CONVERTIBLE": "Convertible",
    "MINIVAN": "Minivan",
    "ESTATE": "Estate",
    "CHASSIS_CAB_VAN": "Van",
    "TRUCK": "Large Van"
  },
  "userRoles": {
    "ADMIN": "Admin",
    "USER": "User",
    "CLIENT_USER": "Client user",
    "DRIVER": "Driver"
  },
  "roleAdmin": {
    "KAM": "KAM",
    "SUPERADMIN": "Superadmin",
    "OPERATIONS_MANAGER": "Operations manager",
    "SALES_MANAGER": "Sales manager"
  },
  "userStatus": {
    "ACTIVE": "Active",
    "INACTIVE": "Inactive",
    "PENDING": "Pending",
    "SUSPENDED": "Suspended"
  },
  "driverStatus": {
    "AVAILABLE": "Available",
    "BUSY": "Busy",
    "OFFLINE": "Offline",
    "ON_BREAK": "On break"
  },
  "driverDocumentCategory": {
    "DNI": "ID Card",
    "DRIVING_LICENSE": "Driving License",
    "DRIVING_POINTS": "Driving Points Certificate",
    "SELF_EMPLOYMENT": "Self-Employment",
    "BANK_ACCOUNT": "Bank Account Certificate",
    "CRIMINAL_RECORD": "Criminal Record Certificate",
    "TAX": "Taxes",
    "SOCIAL_SECURITY": "Social Security",
    "NIE": "NIE"
  },
  "driverDocumentType": {
    "dni": "ID Card (DNI)",
    "front_dni": "ID Card - Front (DNI)",
    "back_dni": "ID Card - Back (DNI)",
    "driving_license": "Driving License",
    "front_driving_license": "Driving License (Front)",
    "back_driving_license": "Driving License (Back)",
    "driving_points_certificate": "Driving Points Certificate",
    "self_employment_registration_fee": "Self-Employment Registration Fee",
    "self_employment_payment_certificate": "Self-Employment Payment Certificate",
    "reta_registration_resolution": "RETA Registration Resolution",
    "bank_account_certificate": "Bank Account Certificate",
    "criminal_record_certificate": "Criminal Record Certificate",
    "tax_census_registration_certificate": "Tax Census Registration Certificate",
    "tax_debt_certificate": "Tax Compliance Certificate",
    "form_036": "Form 036",
    "social_security_compliance_certificate": "Social Security Compliance Certificate",
    "residence_permit_nie": "Residence Permit (NIE)",
    "work_permit_nie": "Work Permit (NIE)"
  },
  "driverDocumentStatus": {
    "PENDING": "Pending",
    "PENDANT": "Pending",
    "VALIDATED": "Validated",
    "APPROVED": "Approved",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired"
  },
  "driverDocumentInvalidationReasonType": {
    "EXPIRED": "Expired",
    "INVALID": "Invalid",
    "ILLEGIBLE": "Illegible",
    "INCOMPLETE": "Incomplete",
    "OTHER": "Other"
  },
  "modals": {
    "multiselection": {
      "title": "Multiselection Check",
      "singleCheckTitle": "Single Check",
      "addNewOption": "+ ADD NEW OPTION",
      "placeholder": "Type here...",
      "save": "SAVE",
      "max_options_exceeded": "The maximum number of allowed options has been exceeded"
    }
  },
  "errors": {
    "sessionExpired": "Session expired",
    "client": {
      "name-required": "Client name is required.",
      "group-required": "Client group is required.",
      "client-type-required": "Client type is required.",
      "principal-client-required": "Main client is required.",
      "contact-email-invalid": "Contact email is not valid.",
      "contact-name-required": "Contact person name is required.",
      "cif-required": "Tax ID (CIF) is required.",
      "invite-delay-required": "The invitation delay is required and must be greater than 0.",
      "reminder-interval-required": "The reminder interval is required and must be greater than 0."
    },
    "billing": {
      "email_send_invoice": "Billing email is required.",
      "document_type": "Document type is required.",
      "iva": "VAT is required.",
      "business_name": "Company name is required.",
      "address": "The address must be at least 5 characters and is required.",
      "postal_code": "Postal code is required.",
      "country": "Country is required.",
      "city": "City is required.",
      "phone": "Phone is required.",
      "entity_number": "Entity reference is mandatory."
    },
    "documents": {
      "type-movement": "Movement type is required.",
      "moment": "Moment is required.",
      "not-file": "You must select a file or a URL.",
      "confirm-delete-document": "Are you sure you want to delete this document?",
      "error-delete-document": "Error deleting the document. Please try again."
    }
  },
  "fileUploadType": {
    "URL": "Url",
    "FILE": "File"
  },
  "dropFile": {
    "dropHere": "Drop the file here...",
    "dropImage": "Drag an image here or click to select",
    "dropFile": "Drag a file or click",
    "viewFile": "View file",
    "deleteFile": "Delete file"
  },
  "EntityDocumentType": {
    "DNI": "Dni (vat number)",
    "CIF": "Cif (vat number)",
    "OTHER": "Other"
  },
  "drivers": {
    "title": "Drivers",
    "create": "Create new driver",
    "IVAIRPF": "MODIFY IVA / IRPF",
    "tabs": {
      "general-data": "General Data",
      "quality": "Quality",
      "certifications": "Certifications",
      "blacklist": "Blacklist",
      "documentation": "Documentation",
      "billing": "Billing",
      "timeline": "Timeline",
      "authorized": "Authorized"
    },
    "list": {
      "image": "Photo",
      "name": "Name",
      "dni": "DNI",
      "cif": "CIF",
      "dni/cif": "DNI/CIF",
      "province": "Province",
      "city": "City",
      "email": "Email",
      "phone": "Phone",
      "created_datetime": "Reg. Date",
      "rating": "Rating",
      "tags": "Tags",
      "validated": "Validation",
      "fortnight_earnings": "Fortnight Earnings",
      "status": "Status",
      "actions": "Actions",
      "searchPlaceholder": "Search...",
      "is_active": "Status",
      "expiredDocuments": "Drivers with expired documents",
      "newDocuments": "Drivers with newly submitted documents",
      "create-driver": "Create new driver",
      "name_filter": "Name",
      "email_filter": "Email",
      "tags_filter": "Tags",
      "is_active_filter": "Active Status",
      "validated_filter": "Validation",
      "rating_filter": "Rating",
      "phone_filter": "Phone",
      "city_filter": "City",
      "province_filter": "Province",
      "expiredDocuments_filter": "Drivers with expired documents",
      "newDocuments_filter": "Drivers with newly submitted documents"
    },
    "generalData": {
      "uploadPhoto": "Upload photo",
      "removePhoto": "Remove photo",
      "photoUploadInfo": "Allows JPG, GIF or PNG. Max Size 800K",
      "firstName": "First Name",
      "firstNameRequired": "First name is required",
      "lastName": "Last Name",
      "lastNameRequired": "Last name is required",
      "dniNie": "DNI/NIE",
      "dniNieRequired": "DNI/NIE is required",
      "cif": "CIF",
      "businessName": "Business name",
      "fullAddress": "Full Address",
      "postalCode": "Postal Code",
      "city": "City",
      "province": "Province",
      "country": "Country",
      "selectCountry": "Select country",
      "email": "Email",
      "emailRequired": "Email is required",
      "phone": "Contact Phone",
      "tags": "Tags",
      "isActive": "Activate/Deactivate Account",
      "blockMissions": "Block Missions",
      "saveChanges": "Save Changes",
      "invalidFileType": "Invalid file type. Only images are allowed (JPG, PNG, WEBP).",
      "fileTooLarge": "File is too large. Maximum size is 5MB."
    },
    "billing": {
      "iban": "IBAN",
      "bic": "BIC",
      "irpf": "Income Tax Withholding",
      "biweeklyBilling": "Billed in the fortnight",
      "saveChanges": "SAVE CHANGES"
    },
    "ivaIrpf": {
      "title": "Modify VAT/Income Tax",
      "ivaApplicado": "Applied VAT",
      "irpfApplicado": "Applied Income Tax",
      "save": "SAVE",
      "saving": "Saving...",
      "load_error": "Error loading default taxes",
      "save_error": "Error saving default taxes",
      "invalid_values": "Values must be valid numbers"
    },
    "blacklist": {
      "createButton": "Create new entry",
      "loading": "Loading blacklist...",
      "noData": "No blacklist entries",
      "deleteConfirm": "Are you sure you want to delete this blacklist entry?",
      "deleteSuccess": "Blacklist entry deleted successfully",
      "deleteError": "Error deleting blacklist entry",
      "delete": {
        "title": "Delete blacklist entry",
        "confirmation": "Are you sure you want to delete the blacklist entry for {{clientName}}?",
        "error": "Error deleting blacklist entry"
      },
      "columns": {
        "client": "Client",
        "movementType": "Movement type",
        "subentity": "Subentity",
        "subentityMovementType": "Subentity movement type",
        "actions": "Actions"
      },
      "modal": {
        "title": "Include blacklist",
        "editTitle": "Edit blacklist",
        "clientLabel": "Client",
        "clientPlaceholder": "Select a client",
        "movementTypeLabel": "Client movement type",
        "movementTypePlaceholder": "Select movement type",
        "addSubentityButton": "Add subentity",
        "subentityLabel": "Subentity",
        "subentityPlaceholder": "Select a subentity",
        "subentityMovementTypeLabel": "Movement type",
        "saveButton": "Save",
        "cancelButton": "Cancel",
        "removeSubentityButton": "Remove"
      }
    },
    "invalidateDocument": {
      "title": "Invalidate document",
      "reasonLabel": "Reason",
      "reasonPlaceholder": "Select a reason...",
      "messageLabel": "Message",
      "messagePlaceholder": "Type a message...",
      "invalidateButton": "Invalidate",
      "errorLoadingReasons": "Error loading invalidation reasons",
      "fieldsRequired": "You must select a reason and write a message",
      "errorInvalidating": "Error invalidating the document. Please try again",
      "reasons": {
        "EXPIRED": "Document expired",
        "ILLEGIBLE": "Document illegible",
        "INVALID": "Incorrect document",
        "INCOMPLETE": "Incomplete document",
        "OTHER": "Other"
      }
    },
    "validateDocument": {
      "expirationDateRequired": "You must enter an expiration date before validating the document",
      "errorValidating": "Error validating the document. Please try again",
      "errorSavingDate": "Error saving the expiration date. Please try again"
    },
    "authorized": {
      "loading": "Loading authorized drivers...",
      "noData": "No authorized drivers",
      "columns": {
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "dni": "ID"
      },
      "filters": {
        "name": "Name",
        "email": "Email",
        "phone": "Phone",
        "dni": "ID"
      }
    },
    "quality": {
      "loading": "Loading quality incidents...",
      "noData": "No quality incidents",
      "columns": {
        "incidentType": "Incident Type",
        "client": "Client",
        "subentity": "Subentity",
        "movementType": "Movement Type",
        "score": "Score",
        "actions": "Actions"
      },
      "filters": {
        "incidentType": "Incident Type",
        "client": "Client",
        "subentity": "Subentity"
      }
    },
    "timeline": {
      "loading": "Loading history...",
      "noData": "No events recorded",
      "columns": {
        "eventType": "Event type",
        "dateTime": "Date and time",
        "actionType": "Action type",
        "user": "User",
        "observations": "Observations"
      }
    },
    "profile": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "VALIDATE": "Validate",
      "NO_VALIDATE": "Pendant",
      "EXPIRED": "Expired",
      "NO_EXPIRED": "Current",
      "NEW_DOCUMENT": "New document",
      "NO_NEW_DOCUMENT": "Without New Document"
    },
    "isActive": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive"
    },
    "actions": {
      "edit": "Edit",
      "view": "View",
      "delete": "Delete"
    },
    "messages": {
      "no_data": "No drivers available",
      "loading": "Loading drivers...",
      "delete_confirm": "Are you sure you want to delete this driver?",
      "delete_success": "Driver deleted successfully",
      "delete_error": "Error deleting driver, driver may have active transports"
    }
  },
  "additionalServices": {
    "applyment-moments": {
      "PICKUP": "Pickup",
      "DROPOFF": "Dropoff",
      "PICKUP_AND_DROPOFF": "Pickup and dropoff",
      "IN_COURSE": "In course",
      "STOPOVER": "Stopover",
      "ALL": "All"
    }
  },
  "addressType": {
    "CRANE_DEPOT": "Crane depot",
    "DEALERSHIP": "Dealership",
    "ITV": "ITV",
    "PRIVATE": "Private",
    "REPAIR_SHOP": "Repair shop",
    "VEHICLE_YARD": "Vehicle yard",
    "WAREHOUSE": "Warehouse"
  },
  "confirmMessages": {
    "RengeKm": "Are you sure you want to delete this distance range?",
    "deleteBilling": "Are you sure you want to delete the billing account?",
    "DeleteTransport": "Are you sure you want to delete the transport?"
  },
  "generalLabels": {
    "option": "Option"
  },
  "errorsGlobal": {
    "required-field": "Required field",
    "element-cant-not-delete": "The element cannot be deleted",
    "import-error": "Format error or no data to import"
  },
  "assign-notifications-modal": {
    "title": "Assign notifications",
    "searchPlaceholder": "Search users",
    "save": "Save",
    "noUsers": "No users assigned to this entity.",
    "noResults": "No users found matching the search criteria.",
    "notifications": {
      "driver-assigned": "Email notification driver assigned",
      "transport-finished": "Email notification transport finished",
      "transport-created": "Email notification transport created",
      "transport-cancelled": "Email notification transport cancelled"
    }
  },
  "popup": {
    "continue": "CONTINUE",
    "confirm": "CONFIRM",
    "accept": "ACCEPT",
    "cancel": "CANCEL"
  },
  "quality-management": {
    "title": "Quality info management",
    "list": {
      "searchPlaceholder": "Search incidents...",
      "type": "Type",
      "mission_id": "Mission ID",
      "entity_sub": "Entity / SUB",
      "opening_date": "Opening Date",
      "update_date": "Update Date",
      "driver": "Driver",
      "status": "Status",
      "responsible": "Responsible",
      "origin": "Origin",
      "origin_admin": "Administrator",
      "origin_client": "Client",
      "actions": "Actions"
    },
    "filters": {
      "driver": "Driver",
      "entity": "Entity",
      "subentity": "Subentity",
      "opening_date": "Opening date",
      "update_date": "Update date",
      "incident_type": "Incident type",
      "status": "Status",
      "mission_id": "Mission ID",
      "origin": "Origin",
      "responsible": "Responsible",
      "city": "City",
      "country": "Country"
    },
    "actions": {
      "edit": "Edit",
      "delete": "Delete",
      "delete_confirm_title": "Delete incident?",
      "delete_confirm_message": "Are you sure you want to delete this quality incident?"
    }
  },
  "incident-management": {
    "title": "Manage incident",
    "created-by": "Created by:",
    "date-time": "Date and time:",
    "incident-details": "Incident details",
    "type": "Type",
    "mission-id": "Mission ID",
    "client": "Client",
    "driver": "Driver",
    "status": "Status",
    "responsible": "Responsible",
    "noData": "No input data",
    "content-placeholder": "Incident management content coming soon",
    "incident-tab-placeholder": "Incident management content coming soon",
    "metrics-tab-placeholder": "Metrics content coming soon",
    "save-changes": "Save changes",
    "timeline": {
      "title": "Incident timeline",
      "modified-by": "Modified by:",
      "add-comment": "Add comment"
    },
    "blacklist": {
      "title": "Blacklisted clients"
    },
    "incident-data": {
      "title": "Incident data",
      "comment": "Comment",
      "attachments": "Attachments"
    },
    "tickets": {
      "title": "Contact tickets",
      "client-link": "Client link",
      "driver-link": "Driver link",
      "save": "Save",
      "icon-link": "Icon link"
    },
    "settings": {
      "title": "Incident settings",
      "admin-responsable": "Responsible administrator",
      "status": "Status",
      "reason": "Reason",
      "sub-reason": "Sub-reason",
      "quantity": "Quantity (Km / Hours / Liters...)",
      "responsibility": "Responsibility",
      "severity": "Severity",
      "severity-note": "Current score: {{current_rating}}pnts Score to withdraw: {{delta}}pnts = Current driver score {{new_rating}}pnts",
      "driver-notice": "Driver notice",
      "exclude-transport-type": "Exclude only by transport type",
      "add-to-blacklist": "Add to client blacklist",
      "blacklist-warning": "This driver has been blacklisted 2 times"
    },
    "regularization": {
      "title": "Economic regularization",
      "no-action": "No action",
      "type": "Regularization type",
      "driver-message": "Driver message",
      "write-here": "Write here...",
      "amount": "Amount",
      "enter-manually": "Enter manually",
      "success": "Regularization created successfully",
      "messages": {
        "delete_title": "Delete regularization",
        "delete_confirm": "Are you sure you want to delete the regularization?",
        "delete_success": "Regularization deleted successfully",
        "delete_error": "Error deleting regularization",
        "invoiced_transport": "Cannot modify/cancel an adjustment that has already been invoiced"
      }
    }
  },
  "metrics": {
    "global-driver-incidents": "Global driver incidents",
    "client-driver-incidents": "Client incidents on driver",
    "global-client-incidents": "Global client incidents",
    "driver": "Driver",
    "motivo": "REASON",
    "submotivo": "SUB-REASON",
    "cantidad": "QUANTITY"
  },
  "incidents": {
    "success": {
      "created": "Incident created successfully",
      "updated": "Incident modified successfully",
      "deleted": "Incident deleted successfully"
    },
    "errors": {
      "cannot_delete_invoiced_adjustment": "An adjustment with associated invoices cannot be deleted",
      "delete_failed": "Incident could not be deleted",
      "message_required": "You have selected to perform an action on the driver, you have not informed the message"
    }
  },
  "tooltipsLabels": {
    "base_price": "Base price",
    "fuel_price": "Fuel",
    "outbound_price": "Outbound price",
    "return_price": "Return price",
    "ferry": "Ferry",
    "toll": "Toll",
    "optional_expenses_price": "Optional expenses",
    "additionals_services": "Additional services",
    "additionals_costs": "Additional costs",
    "adjustments": "Regularizations",
    "total": "TOTAL"
  }
}
